import { Component, Inject, ElementRef, ViewChild, ViewEncapsulation, NgZone, ViewChildren, QueryList, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main/main.service';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Validators, NgForm, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoaderService } from 'src/app/services/interceptor/loader.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import * as Regex from 'src/app/shared/regex'
import { environment } from 'src/environments/environment';
import { PhoneNumberPipe } from 'src/app/pipes/phoneNumber';
import { Subscription } from 'rxjs';
import { PersonaService } from 'src/app/services/persona/persona.service';
declare var Stripe: any;
import { GlobalFilterService } from 'src/app/services/shared/global-filter.service';
import { SignatureNewComponent } from 'src/app/shared/signature-new/signature-new.component';
import { StripeService } from 'src/app/services/stripe/stripe.service';
import { PrepaidCardService } from 'src/app/shared/prepaid-card-modal/prepaid-card.service';
import { ALLOWED_PAYBACK_METHODS, MIN_BIRTH_DATE, PROPOSAL_DURATIONS } from '../../../core/constants/shared-data.constants';
import { getUserProfile, getUserProfiles, getDoctorSettings, getStoredLocations } from 'src/app/core/session';

@Component({
    selector: 'app-contract-dialog',
    templateUrl: 'contract-modal.component.html',
    styleUrls: ['./contract-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [PhoneNumberPipe]
})
export class ContractDialogComponent implements OnInit, OnDestroy {

    public document;
    public pdfSrc =
        'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf';

    public mask = Regex.mobile_mask;
    public dobMask = Regex.dob_mask;
    public contractData: any;
    public cancel_contract_step: number = 1;
    public selected_option: any;
    public payment_option = {
      cardName: null,
      paymentType: null,
      terms: null
    };
    public SSN = Regex.SSN;
    public EIN = Regex.EIN;
    public payment_result: any;
    public payment_stripe_data: any;
    public edit_recurring_step: number = 1;
    public edit_recurring_data: any = {};
    public loader: boolean = false;
    public send_email: any;
    public send_phone: any;
    public missing_payments: any = [];
    public serviceBreakDown: any[] = [
        {
            service: '',
            price: '',
            contract_id: '',
            service_id: ''
        }
    ];
    totalServAmt: number;
    public contract_id: number;
    emailCtrl = new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern(Regex.email_regex)]);
    emails: string[] = [];
    environment: any = localStorage.getItem('environment') || '';
    proposalSent = false;
    fillForm = false;
    proposalStartDate = {};
    proposalEndDate = {};
    changeReason: string = '';
    cancelContractConnectedAccountAllow: any = '';
    proposalDuration: any = PROPOSAL_DURATIONS;
    proposalDurationModel = this.proposalDuration[3].value;
    callReasonModel: any;
    responseSubmitted = false;
    @ViewChild('emailInput', { static: false }) emailInput: ElementRef<HTMLInputElement>;
    new_address: {
        new_address_1?: string,
        new_address_2?: string,
        state?: string,
        zip_code?: string,
        city?: string,
        checked?: boolean,
        country?: string,
        cardError?: string,
        saveDefault?: string,
        country_code?: string
    } = {};
    add_product = {
        doctor_id: null,
        pc_id: null,
        pc_name: '',
        service_amount: null,
        dp_amount: 0,
        terms: '',
        description: ''
    };
    userInfo = getUserProfiles();
    writeToUsMessage = '';
    industryList: any;
    sub_industries: any[];
    isEdit: boolean;
    isLocationSubmitted: boolean;
    businessDetailsForm: any;
    office_zip: any;
    office_zipObj: any;
    minDate = MIN_BIRTH_DATE;
    all_locations = localStorage.getItem('locations') ? getStoredLocations() : [];
    subscription_id: any;
    tcr_height = 1;
    is_allowed: boolean;
    subscription_data: any;
    contractDocsRequired: any = [];
    disutedPayments: any = [];
    CustomerAdditionalDocs: { file_name: String, document_file: any }[] = [];
    is_reupload: any = 0;
    is_submitted: number = 0;
    public timezone: any;
    doctorSettings = localStorage.getItem('doctorSettings') && getDoctorSettings();
    public offer_id: any;
    addingBank: boolean = false;
    skipCancellationFee: boolean = false;

    constructor(
        public mainService: MainService,
        public auth: AuthService,
        public dialog: MatDialog,
        public loaderService: LoaderService,
        public _formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<ContractDialogComponent>,
        public router: Router,
        public zone: NgZone,
        public _persona: PersonaService,
        public fb: UntypedFormBuilder,
        public globalFilterService: GlobalFilterService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public datepipe: DatePipe,
        private authService: AuthService,
        private phoneNumberPipe: PhoneNumberPipe,
        private stripe: StripeService,
        private prepaidCard: PrepaidCardService,
    ) {}
    changePaymentDateCard: any = {};
    edit_contract_data = {
        terms: null,
        selected_card: null,
        minimum_amount: null,
        maximum_amount: null,
        minimum_tenure: null,
        maximum_tenure: null,
        cardName: null,
        advance_interest_amount: null,
        tenure: null,
        new_recurring_amount: null,
        new_recurring_amount_crf: null,
        treatment_amount: null,
        notes: '',
        oldFinanceDetails: {
            "interest_rate": null,
            "interest_rate_to_show": null,
            "number_of_payments": null,
            "treatment_amount": null,
            "financed_amount": null,
            "downpayment_amount": null,
            "recurring_amount": null,
            "remaining_payments": null,
            "advance_interest_amount": null,
            "recurring_extra_amount": null,
            "recurring_extra_percent": null,
            "threshold_amount": null,
            "threshold_recurring_extra_amount": null,
            "threshold_recurring_extra_percent": null
        },
        newFinanceDetails: {
            "interest_rate": null,
            "interest_rate_to_show": null,
            "number_of_payments": null,
            "treatment_amount": null,
            "financed_amount": null,
            "downpayment_amount": null,
            "recurring_amount": null,
            "remaining_payments": null,
            "advance_interest_amount": null,
            "recurring_extra_amount": null,
            "recurring_extra_percent": null,
            "threshold_amount": null,
            "threshold_recurring_extra_amount": null,
            "threshold_recurring_extra_percent": null
        }
    };
    edit_contract_step = 1;
    plan_array = [];
    editContractResult = {
        is_error: 0,
        override_text: null
    }
    editContractStripeData = {
        token: {
            id: null,
            card: {
                last4: null
            }
        }
    }
    profile = getUserProfile();
    profile_subscriber: Subscription;
    ind_id = 0;
    is_crime_reason = 0;
    marketControls = this._formBuilder.group(
        {
            "suggestions": ['', []],
            "address": [this.profile && this.profile.practice_address, Validators.required],
            "zipCode": [this.profile && this.profile.zip, [Validators.required]],
            "city": [{ value: this.profile && this.profile.city, disabled: false }, [Validators.required]],
            "state": [{ value: this.profile && this.profile.state_name, disabled: true }, [Validators.required]]

        })
    locationManageForm: UntypedFormGroup;
    showDeferredNote: boolean = false;
    showDeferredBenefitsNote: boolean = false;

    new_edit_contract_values: any = {
        new_treatment_amount: undefined,
        new_number_of_payments: undefined,
        desired_recurring_amount: undefined
    };
    transaction_fee_values: any;
    contract_values_v5: any;
    contract_types_new_edit: any = [6, '6']; //add the contract types to implement the new edit contract flow
    deferred_continue_edit: boolean = false;

  businessStripeDetailsForm = this.fb.group({
    // businessName: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    businessEmail: this.fb.control('', [Validators.required, Validators.maxLength(100), Validators.pattern(Regex.email_regex)]),
    businessPhoneNumber: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    // managerPhoneNumber: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    businessAddress: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    zipPostalCode: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    city: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    state: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
    businessType: this.fb.control('', [Validators.required]),
    business_ein: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
  });

  consentForm = this.fb.group({
    signatureField: this.fb.control('', [Validators.required]),
    terms: this.fb.control(false, [Validators.required, Validators.requiredTrue]),
  });

  currentStripeForm = 1;
  @ViewChild('businessDetailsLi', {static: false}) businessDetailsLi!: ElementRef;
  @ViewChild('bankDetailsLi', {static: false}) bankDetailsLi!: ElementRef;
  liHeight: number | null = 480;
  bankliHeight: number | null = 480;


    showTransactionWord: boolean = true;
    ngOnInit() {
      if(this.data.type == '56') {
        this.auth.showPersona.subscribe((data) => {
          if (data == 1 && this.auth.showNextKYB == 1) {
            this.auth.showNextKYB = 0;
            this.dialogRef.close("1");
          } else {

          }
        })
      }
        this.timezone = this.mainService.getCurrentTimezone();
        this.changeReason = '';
        this.subscription_data = localStorage.getItem('subscription_data') ? JSON.parse(localStorage.getItem('subscription_data')): '';
        let userSetting = localStorage.getItem('doctorSettings') ? getDoctorSettings() : [];
        this.cancelContractConnectedAccountAllow = Number(userSetting.contract_cancel_with_stripe_account);
        this.subscription_id = userSetting.subscription_id;

        this.profile_subscriber = this.auth.userProfileData$.subscribe(data => {
            this.profile = getUserProfile();
        })
        this.customerDetails.controls['customerMinor'].valueChanges.subscribe((res: any) => {
            if (res == 1) {
                const arr1 = ['guardianFirstName', 'guardianLastName']
                for (let i of arr1) {
                    this.customerDetails.controls[i].setValidators(Validators.required);
                    this.customerDetails.controls[i].updateValueAndValidity();
                }
            }
            else {
                const arr1 = ['customerFirstName', 'customerLastName']
                for (let i of arr1) {
                    this.customerDetails.controls[i].setValidators(Validators.required);
                    this.customerDetails.controls[i].updateValueAndValidity();
                }

                const arr2 = ['guardianFirstName', 'guardianLastName']
                for (let j of arr2) {
                    this.customerDetails.controls[j].clearValidators();
                    this.customerDetails.controls[j].updateValueAndValidity();
                }
            }
        })
        if (this.data && this.data.type == 1) {
            this.getContractDetails(this.data.send_data.contract_id)
        }
        if (this.data && this.data.type == 7) {
            this.setCancelContractData(this.data);
        }
        if (this.data && this.data.type == 48) {
            this.setEditContractData(this.data);
        }
        if (this.data && this.data.type == 9) {
            this.setChangePaymentDateData(this.data);
            this.changePaymentDateCard = this.contractData.payment_sources[0];
        }
        if (this.data && this.data.type == 60) {
            this.contractDocsRequired = this.data.contractDocsRequired;
            this.disutedPayments = this.data.disutedPayments;
        }
        if (this.data && this.data.type == 41) {
            this.zipPostalCode = this.profile.zip;
            if (this.profile && this.profile.role_id != 4) {
                let location = this.globalFilterService.getFilterObj('location')
                if (location) {
                    this.zipPostalCode = location.zip;
                    this.marketControls.patchValue({
                        address: location.practice_address,
                        zipCode: location.zip,
                        city: location.city,
                        state: location.state_name
                    })
                }
            }
        }
        if (this.data && this.data.type == 25) {
            if (this.data.send_data.selected_option) {
                this.callReasonModel = this.data.send_data.reason[parseInt(this.data.send_data.selected_option)].reason;
            } else {
                this.callReasonModel = this.data.send_data.reason[0].reason;
            }
            this.reasonPrioritySet(this.callReasonModel);
        }
        if (this.data && this.data.type == 37) {
            this.payment_option = {
                cardName: null,
                paymentType: null,
                terms: null
            };
            setTimeout(() => {
                this.mainService.stripe_element.unmount('#' + 'add_card');
                this.mainService.stripe_element.mount('#' + 'add_instant_card');
            }, 200);
        }

        if (this.data && this.data.type == 50) {
            this.initLocationDetailForm();
            this.getIndustryList();
            this.authService.userProfileData$
                .subscribe((data: any) => {
                    if (data && data[0]) {
                        this.profile = data[0];
                    }
                });
            this.isEdit = this.data['isEdit'];
            if (this.isEdit) {
                let arr1 = ['ind_id', 'sub_ind_id'];
                for (let j of arr1) {
                    this.locationManageForm.controls[j].clearValidators();
                    this.locationManageForm.controls[j].updateValueAndValidity();
                }
                this.initPatchLocationValue();
            }
        }

        if (this.data && this.data.type == 51) {
            // this.initBusinessDetailsForm();
            this.patchBusinessDetails();
            this.authService.userProfileData$
                .subscribe((data: any) => {
                    if (data && data[0]) {
                        this.profile = data[0];
                    }
                });
        }
        if (this.data && this.data.type == 56) {
            this.ind_id = this.profile.ind_id;
            this.inItBankForm();
        }
        if (this.data && this.data.type == 57) {
            this.inItPracticeForm();
        }

        // this.showDeferredNote = this.contractData.is_contract_deferred == 1 && this.contractData.contract_type == 6;

        if(this.doctorSettings.transaction_fee_ui_modal == 2){
            this.showTransactionWord = false;
        }
    }
    setStripeElement(id) {
        setTimeout(() => {
            this.mainService.stripe_element.mount('#' + id);
        }, 200);
    }
    changePaymentDateCardList: any = [];
    public setChangePaymentDateData(data) {
        this.contractData = data.send_data;
        this.edit_recurring_step = 1;
        this.payment_stripe_data = {};
        this.selected_option = null;
        this.payment_result = {};
        this.payment_option = {
            cardName: null,
            paymentType: null,
            terms: null
        };
        let max_days = 90;
        // send_data.doctor_settings[0].extend_payment_days_doctor
        if (this.contractData.doctor_settings && this.contractData.doctor_settings[0] && this.contractData.doctor_settings[0].hasOwnProperty('extend_payment_days_doctor')) {
            max_days = this.contractData.doctor_settings[0].extend_payment_days_doctor;
        }
        var next_date = new Date(this.contractData.next_payment_date)
        next_date = next_date > new Date() ? next_date : new Date();
        this.edit_recurring_data = {
            minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            maxDate: new Date(new Date(next_date).setDate(new Date(next_date).getDate() + max_days)),
            payment_date: null
        }

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });
        this.showDeferredBenefitsNote = this.contractData.doctor_settings[0].deferred_benefits == 1 ? true : false;
        // setTimeout(() => {
        //     this.mountCard();
        //     // this.mainService.stripe_element.mount('#' + 'edit_recurring');
        // }, 1000);
    }

    public createStripeToken(type) {
        this.loaderService.show();
        if (!this.payment_option.cardName || this.payment_option.cardName.trim().length == 0) {
            this.mainService.customPopups('Please enter Cardholder name', 2);
            this.loaderService.hide();
            return false;
        }
        if (this.payment_option.cardName.trim().length > 100) {
            this.mainService.customPopups('Cardholder name cannot contain more than 100 characters', 2);
            this.loaderService.hide();
            return false;
        }
        this.loader = true;
        const data = {
            name: this.payment_option.cardName
        };
        this.mainService.stripe.createToken(this.mainService.stripe_element, data).then(response => {
            if (response && response.token && response.token.id) {
                this.payment_stripe_data = response;
                this.editContractStripeData = response;
                if (type == 'cancel_contract') {
                    this.cancel_contract_step = this.cancel_contract_step + 1;
                }
                if (type == 'edit_recurring') {
                    this.edit_recurring_step = this.edit_recurring_step + 1;
                }
                if (type == 'edit_contract') {
                    this.edit_contract_step = this.edit_contract_step + 1;
                }
                this.loaderService.hide();
            } else {
                this.loaderService.hide();
                this.loader = false;
                this.mainService.customPopups(response.error.message, 1);
            }
        });

    }

    public createStripeTokenV2(type) {
        this.loaderService.show();
        if (!this.payment_option.cardName || this.payment_option.cardName.trim().length == 0) {
            this.mainService.customPopups('Please enter Cardholder name', 2);
            this.loaderService.hide();
            return false;
        }
        if (this.payment_option.cardName.trim().length > 100) {
            this.mainService.customPopups('Cardholder name cannot contain more than 100 characters', 2);
            this.loaderService.hide();
            return false;
        }
        this.loader = true;
        const data = {
            name: this.payment_option.cardName
        };
        setTimeout(async () => {
            let response = await this.stripe.stripe.confirmCardSetup(
                this.stripe.setup_intent_secret.setup_intent_secret,
                {
                    payment_method: {
                        card: this.stripe.paymentElement,
                        billing_details: {
                            name: this.payment_option.cardName
                        },
                    },
                }
            );
            if (response.error) {
                this.mainService.customPopups(response.error.message, 1)
                this.loaderService.hide();
                return
            }
            if (response.setupIntent && response.setupIntent.status === "succeeded") {
                let data = await this.__getCardInfo(response.setupIntent.id);

                // Option 4 = customer's new card (2 = business's own card, not checked).
                if (this.selected_option == 4 && !this.prepaidCard.check(data, 'payment')) {
                    this.loaderService.hide();
                    return;
                }

                this.payment_stripe_data = data;
                this.editContractStripeData = data;
                if (type == 'cancel_contract') {
                    this.cancel_contract_step = this.cancel_contract_step + 1;
                }
                if (type == 'edit_recurring') {
                    this.edit_recurring_step = this.edit_recurring_step + 1;
                }
                if (type == 'edit_contract') {
                    this.edit_contract_step = this.edit_contract_step + 1;
                }
                this.loaderService.hide();
            }
        }, 1500);
    }

    async __getCardInfo(id) {
        try {
          let obj = {
            access_token: localStorage.getItem('token'),
            seti_id: id
          };
          let result = await this.mainService.api(obj, 'card_detail_through_setup_intent', false).toPromise();
          if (result) {
            return result.result
          }
          return;
        } catch (error) {
          console.error('Error retrieving card info:', error);
        }
      }

    public backRecurringDateStep() {
        this.edit_recurring_step = this.edit_recurring_step - 1;
        if (this.edit_recurring_step == 2 && this.edit_recurring_data.total_rec_amount == 0) {
            this.edit_recurring_step = this.edit_recurring_step - 1;
        }
    }

    public closePop() {
        this.mainService.writeToDenefit.next(false);
        this.dialogRef.close();
    }

    public nextRecurringStep() {
        if (new Date(this.contractData.next_payment_date).toLocaleDateString() == new Date(moment(this.edit_recurring_data.payment_date).format('MM/DD/YYYY')).toLocaleDateString()) {
            this.mainService.customPopups('Please select a new payment date.', 1);
            return;
        }

        if (this.edit_recurring_step === 1) {
            var next_payment_date = moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD');
            var minDate = new Date(this.edit_recurring_data.minDate).setHours(0, 0, 0, 0);
            var maxDate = new Date(this.edit_recurring_data.maxDate).setHours(0, 0, 0, 0);
            var selDate = new Date(this.edit_recurring_data.payment_date).setHours(0, 0, 0, 0);
            if (selDate < minDate || selDate > maxDate) {
                this.mainService.customPopups('Please select new recurring date.', 1);
                return false;
            }

            this.edit_recurring_data.newRecurringDate = moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy');
            if (!next_payment_date || next_payment_date == '' || next_payment_date == 'Invalid date') {
                this.mainService.customPopups('Please select new recurring date', 1);
                return false;
            }

            if (moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy') == this.contractData.next_payment_date) {
                this.mainService.customPopups('Please select new recurring date', 1);
                return false;
            }
            if (moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy') != this.contractData.next_payment_date) {
                let data = {
                    access_token: localStorage.getItem('token'),
                    contract_id: this.contractData.contract_id,
                    new_recurring_date: moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD')
                };
                this.mainService.api(data, 'check_edit_recurring_date_amount', false)
                    .subscribe((data: any) => {
                        if (data.is_error == 0) {
                            this.edit_recurring_data.edit_recurring_amount = data.amount || 0;
                            this.edit_recurring_data.total_rec_amount = parseFloat((this.edit_recurring_data.edit_recurring_amount + (this.contractData.late_fee * this.contractData.missing_payments))).toFixed(2);
                            if (this.edit_recurring_data.total_rec_amount > 0) {
                                this.edit_recurring_step = this.edit_recurring_step + 1;
                            } else {
                                this.edit_recurring_step = this.edit_recurring_step + 2;
                            }
                        }
                    }, (error: any) => {
                        console.log(error);
                    });
            }
        } else if (this.edit_recurring_step === 2) {
            if (!this.payment_option.paymentType) {
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeTokenV2('edit_recurring');
            } else {
                this.edit_recurring_step = 3;
            }
        } else if (this.edit_recurring_step === 3) {
            if (this.changeReason) {
                this.editRecDate();
            } else {
                this.mainService.customPopups('Please mention reason.', 1);
            }
        } else if (this.edit_recurring_step === 4) {
            this.editRecDate();
        }
    }

    updateNote(event) {
        if(this.contractData.contract_type == 6 && this.contractData.is_contract_deferred == 1) {
            const d1 = moment(event).startOf('day');
            const d2 = moment(this.contractData.next_payment_date).endOf('day');
            this.showDeferredNote = d1.isBefore(d2) ? false : this.contractData.doctor_settings[0].deferred_benefits == 1 ? false : true;
            this.showLabel();
        }
    }

    public editRecDate() {
        var params = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            payment_mode: this.selected_option, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            stripe_token: this.payment_stripe_data ? this.payment_stripe_data.id : 0,
            note: this.changeReason,
            doctor_id: this.contractData.doctor_id,
            pf_id: this.contractData.pf_id,
            source_id: this.changePaymentDateCard ? this.changePaymentDateCard.source_id : '',
            next_payment_date: moment(this.edit_recurring_data.payment_date).format('YYYY-MM-DD'),
            amount: this.edit_recurring_data.edit_recurring_amount ? this.edit_recurring_data.edit_recurring_amount : 0,
            late_fee: (this.contractData.late_fee * this.contractData.missing_payments),
            seti_id: this.stripe && this.stripe.setup_intent_secret ? this.stripe.setup_intent_secret.setup_intent_id : null
        };
        if (this.selected_option == 1 || this.selected_option == 3) {
            delete params.stripe_token;
        }
        if (params.payment_mode == 4) {
            params.payment_mode = 1;
            delete params.source_id;
        }
        if (params.payment_mode == 2 || params.payment_mode == 3) {
            delete params.source_id;
        }
        if (this.selected_option == 5) {
            params.payment_mode = 4;
            params.source_id = this.contractData.plaidAccount && this.contractData.plaidAccount[0] && this.contractData.plaidAccount[0].source_id ? this.contractData.plaidAccount[0].source_id : 0;
        }

        if(this.contractData.contract_type == 6 && this.contractData.is_contract_deferred == 1) {
            params['deferred_benefits'] = 0;
        }

        this.mainService.api(params, 'edit_contract_recurring_date', false)
            .subscribe(async (data: any) => {
                if (data.three_d_required) {
                    let result = await this.stripe.confirm3DSCharge(data.payment_intent.client_secret, data.payment_intent.payment_method);
                    if (!result) {
                        this.loaderService.hide();
                        return;
                    }
                }
                this.edit_recurring_step = 4;
                this.payment_result = data;
                if (data && data.is_error == 0) {
                    this.send_email = this.contractData.patient_email;
                    this.send_phone = this.contractData.patient_mobile && this.contractData.patient_mobile.split('-').length ? this.contractData.patient_mobile.split('-')[1] : this.contractData.patient_mobile;
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                            this.payment_result.override_text = "Your card has been declined";
                        }
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    public setCancelContractData(data) {
        this.contractData = data.send_data;
        if (this.contractData.pf_status == 3 && !this.contractData.gp_recovered) {
            return;
        }
        this.cancel_contract_step = 1;
        this.skipCancellationFee = this.contractData.skipCancellationFee
        this.payment_stripe_data = {};
        this.selected_option = null;
        this.payment_result = {};
        this.payment_option = {
            cardName: null,
            paymentType: null,
            terms: null
        };
        // setTimeout(() => {
        //     // this.mainService.stripe_element.mount('#' + 'cancel_contract');
        //     this.mountCard();
        // }, 1000);

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });
        let default_card = this.changePaymentDateCardList.filter(card => card.source_id == this.contractData.source_id);
        if (default_card && default_card[0]) {
            this.selPaymentCard(default_card[0], false);
        }
    }

    public sendContractPdf(step) {
        let data = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            email: this.send_email,
            mobile_number: this.send_phone,
            type: 1
        };

        if (!this.send_email) {
            this.mainService.customPopups('Please enter a valid email address', 2);
            return false;
        }
        if (this.send_phone) {
            let phone = this.send_phone.replace(/-/g, '');
            if (!phone || phone.length < 9) {
                this.mainService.customPopups('Please enter valid phone number', 2);
                return false;
            }
            data.mobile_number = this.send_phone.replace(/-/g, '');
        }

        if (step == 'edit_recurring_step') {
            data.type = 2;
            data['old_recurring_date'] = moment(this.contractData.next_payment_date).format('MM/DD/yyyy');
            data['new_recurring_date'] = moment(this.edit_recurring_data.payment_date).format('MM/DD/yyyy');
        } else if (step == 'edit_contract_step') {
            data.type = 3;
            data['old_treatment_amount'] = this.edit_contract_data.oldFinanceDetails.treatment_amount.toFixed(2);
            data['new_treatment_amount'] = this.edit_contract_data.newFinanceDetails.treatment_amount.toFixed(2);
            data['old_financed_amount'] = this.edit_contract_data.oldFinanceDetails.financed_amount.toFixed(2);
            data['new_financed_amount'] = this.edit_contract_data.newFinanceDetails.financed_amount.toFixed(2);
            data['old_downpayment_amount'] = this.edit_contract_data.oldFinanceDetails.downpayment_amount.toFixed(2);
            data['new_downpayment_amount'] = this.edit_contract_data.newFinanceDetails.downpayment_amount.toFixed(2);
            data['old_interest_rate'] = this.edit_contract_data.oldFinanceDetails.interest_rate.toFixed(2);
            data['new_interest_rate'] = this.edit_contract_data.newFinanceDetails.interest_rate_to_show.toFixed(2) || this.edit_contract_data.newFinanceDetails.interest_rate.toFixed(2);
            data['old_total_payments'] = this.edit_contract_data.oldFinanceDetails.number_of_payments;
            data['new_total_payments'] = this.edit_contract_data.newFinanceDetails.number_of_payments;
            data['old_remaining_payments'] = this.edit_contract_data.oldFinanceDetails.remaining_payments;
            data['new_remaining_payments'] = this.edit_contract_data.newFinanceDetails.remaining_payments;
            data['old_recurring_amount'] = this.contractData.old_recurring_amount_with_fee.toFixed(2);
            data['new_recurring_amount'] = Number(this.edit_contract_data.newFinanceDetails.recurring_amount).toFixed(2);
            data['old_interest_text'] = (!this.contractData.interest_rate_to_show || (this.contractData.interest_rate == this.contractData.interest_rate_to_show)) ? 'C' : 'F';
            data['new_interest_text'] = (!this.edit_contract_data.newFinanceDetails.interest_rate_to_show || (this.edit_contract_data.newFinanceDetails.interest_rate == this.edit_contract_data.newFinanceDetails.interest_rate_to_show)) ? 'C' : 'F';

            if (this.contractData.contract_type == 2 || this.contractData.contract_type == 4 || this.contractData.contract_type == 6) {
                data['old_upfront_fee'] = this.contractData.old_upfront_with_fee ? this.contractData.old_upfront_with_fee.toFixed(2) : 0;
                data['new_upfront_fee'] = this.contractData.new_upfront_with_fee ? this.contractData.new_upfront_with_fee.toFixed(2) : 0;

                    if(this.contract_types_new_edit.includes(this.contractData.contract_type) && parseFloat(data['new_upfront_fee'] || 0) < parseFloat(data['old_upfront_fee'] || 0)) {
                    data['new_upfront_fee'] = data['old_upfront_fee'];
                }
            }
        }
        this.mainService.api(data, 'send_contract_pdf', false)
            .subscribe((data: any) => {
                if (data && data.is_error == 0) {
                    if (step == 'cancel_contract_step') {
                        this.cancel_contract_step = 5;
                    } else if (step == 'edit_recurring_step') {
                        this.edit_recurring_step = 5;
                    } else if (step == 'edit_contract_step') {
                        this.edit_contract_step = 8;
                    }
                }
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.customPopups(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });

    }

    public gotoNextStepCancelContract() {
        if (this.cancel_contract_step === 1) {
            if(this.skipCancellationFee){
                this.cancel_contract_step = 3;
            } else {
                this.cancel_contract_step = 2;
            }
        } else if (this.cancel_contract_step === 2) {
            if (!this.payment_option.paymentType) {
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeTokenV2('cancel_contract');
            } else {
                this.cancel_contract_step = 3;
            }
        } else if (this.cancel_contract_step === 3) {
            if (this.changeReason) {
                this.cancelTheContract();
            } else {
                this.mainService.customPopups('Please mention reason.', 1);
            }
        } else if (this.cancel_contract_step === 4) {
            this.cancelTheContract();
        }
    }

    public backCancelContractStep() {
        if(this.cancel_contract_step == 3 && this.skipCancellationFee){
            this.cancel_contract_step = 1
        } else
        this.cancel_contract_step = this.cancel_contract_step - 1;
    }

    public cancelTheContract() {
        var params = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            payment_mode: this.selected_option, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            stripe_token: this.payment_stripe_data ? this.payment_stripe_data.id : 0,
            note: this.changeReason,
            doctor_id: this.contractData.doctor_id,
            source_id: this.contractData.source_id_new ? this.contractData.source_id_new : this.changePaymentDateCard.source_id ? this.changePaymentDateCard.source_id : this.contractData.source_id,
            seti_id: this.stripe && this.stripe.setup_intent_secret ? this.stripe.setup_intent_secret.setup_intent_id : null,
            skipCancellationFee: this.skipCancellationFee ? 1 : 0
        };
        if (this.selected_option == 1 || this.selected_option == 3) {
            delete params.stripe_token;
        }

        if (params.payment_mode == 4) {
            params.payment_mode = 1;
        }
        if (this.selected_option == 5) {
            params.payment_mode = 4;
        }

        this.mainService.api(params, 'charge_and_cancel_contract', false)
            .subscribe(async (data: any) => {
                if (data.three_d_required) {
                    let result = await this.stripe.confirm3DSCharge(data.payment_intent.client_secret, data.payment_intent.payment_method);
                    if (!result) {
                        this.loaderService.hide();
                        return;
                    }
                }
                this.cancel_contract_step = 4;
                this.payment_result = data;
                if (data && data.is_error == 0) {
                    this.send_email = this.contractData.patient_email;
                    this.send_phone = this.contractData.patient_mobile && this.contractData.patient_mobile.split('-').length ? this.contractData.patient_mobile.split('-')[1] : this.contractData.patient_mobile;
                }
                if (data.is_error == 1) {
                    if (data.override_text) {
                        if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                            this.payment_result.override_text = "Your card has been declined";
                        }
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    // fromUser = false for the automatic default-card preselect: a barred prepaid
    // default is just left unselected instead of popping the modal on open.
    selPaymentCard(d, fromUser = true) {
        if (fromUser ? !this.prepaidCard.check(d, 'payment') : this.prepaidCard.isBlocked(d, 'payment')) {
            return;
        }
        this.changePaymentDateCard = d;
        setTimeout(() => {
            const radioButton = document.getElementById(d.source_id) as HTMLInputElement;
            if (radioButton) {
              radioButton.checked = true;
            }
          });
    }

    async newEditContract(payload: any) {
        payload = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contractData.contract_id,
            ...payload,
            ...this.new_edit_contract_values
        };

        if (payload.get_values == 1) {
            const data = await this.mainService.api(payload, 'edit_financing_details_v5', false).toPromise();
            if (data.is_error == 1) throw new Error(data.err || data.original_text)
            this.transaction_fee_values = data.transaction_fee_values;
            this.contract_values_v5 = data.contract_values;
            return data.contract_values;
        }

        if (payload.get_values == 0) {
            const data = await this.mainService.api(payload, 'edit_financing_details_v5', false).toPromise();
            if (data.is_error == 1) throw new Error(data.err || data.original_text)
            return data
        }
    }

    calculate_transaction_fee(v: number) {
        return v > 0 && this.transaction_fee_values ? parseFloat((v >= this.transaction_fee_values.threshold_amount ? this.transaction_fee_values.threshold_recurring_extra_amount + (this.transaction_fee_values.threshold_recurring_extra_percent * v / 100) : this.transaction_fee_values.recurring_extra_amount + (this.transaction_fee_values.recurring_extra_percent * v / 100)).toFixed(2)) : 0;
    }

    goBackStepEditContract() {
        if (this.edit_contract_step === 6) {
            if (this.contract_types_new_edit.includes(this.contractData.contract_type)) {
                if (this.contractData.net_remaining_upfront_fee > 0) {
                    this.edit_contract_step = this.edit_contract_step - 1;
                } else {
                    this.edit_contract_step = this.edit_contract_step - 2;
                }
            } else {
                if (this.edit_contract_data.newFinanceDetails.advance_interest_amount > this.edit_contract_data.oldFinanceDetails.advance_interest_amount) {
                    this.edit_contract_step = this.edit_contract_step - 1;
                } else {
                    this.edit_contract_step = this.edit_contract_step - 2;
                }
            }
        }
    }

    gotoNextStepEditContract() {
        if (this.edit_contract_step === 1) {
            if (this.contract_types_new_edit.includes(this.contractData.contract_type)) {
                if (!(this.new_edit_contract_values['new_treatment_amount'] || this.new_edit_contract_values['new_numbe_of_payments'] || this.new_edit_contract_values['desired_recurring_amount'])) {
                    if(!this.new_edit_contract_values['new_treatment_amount']) {
                        this.mainService.customARPopups(`Please enter New Service Amount.`, 1)
                    } else {
                        this.mainService.customARPopups(`Please enter atleast one out of \nNew Service Amount OR New Contract Term OR Expected Recurring.`, 1)
                    }
                    return;
                }

                if (this.new_edit_contract_values['new_treatment_amount'] == this.contractData.treatment_amount) {

                    if (!this.new_edit_contract_values['new_number_of_payments'] && (!this.new_edit_contract_values['desired_recurring_amount'] || this.new_edit_contract_values['desired_recurring_amount'] < 1)) {
                        this.mainService.customARPopups(`Please enter a different service amount than the original service amount.`, 1);
                        return;
                    }

                    if (!this.new_edit_contract_values['desired_recurring_amount'] && (!this.new_edit_contract_values['new_number_of_payments'] || this.new_edit_contract_values['new_number_of_payments'] == this.contractData.number_of_payments)) {
                        this.mainService.customARPopups(`Please enter a different service amount than the original service amount.`, 1);
                        return;
                    }
                }

                this.newEditContract({ get_values: 1 })
                    .then((contract_values: any) => {
                        this.edit_contract_data.oldFinanceDetails = {
                            "interest_rate": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
                            "interest_rate_to_show": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
                            "number_of_payments": this.contractData.number_of_payments,
                            "treatment_amount": this.contractData.treatment_amount,
                            "financed_amount": this.contractData.financed_amount,
                            "downpayment_amount": this.contractData.downpayment_amount,
                            "recurring_amount": this.contractData.recurring_amount,
                            "remaining_payments": this.contractData.remaining_payments,
                            "advance_interest_amount": this.contractData.advance_interest_amount,
                            "recurring_extra_amount": this.contractData.recurring_extra_amount,
                            "recurring_extra_percent": this.contractData.recurring_extra_percent,
                            "threshold_amount": this.contractData.threshold_amount,
                            "threshold_recurring_extra_amount": this.contractData.threshold_recurring_extra_amount,
                            "threshold_recurring_extra_percent": this.contractData.threshold_recurring_extra_percent
                        }
                        this.edit_contract_data.newFinanceDetails = {
                            "interest_rate": contract_values.interest_rate,
                            "interest_rate_to_show": contract_values.interest_rate_to_show,
                            "number_of_payments": contract_values.number_of_payments,
                            "treatment_amount": contract_values.treatment_amount,
                            "financed_amount": contract_values.financed_amount,
                            "downpayment_amount": contract_values.downpayment_amount,
                            "recurring_amount": contract_values.recurring_amount,
                            "remaining_payments": contract_values.remaining_payments,
                            "advance_interest_amount": contract_values.new_upfront_amount,
                            "recurring_extra_amount": contract_values.recurring_extra_amount,
                            "recurring_extra_percent": contract_values.recurring_extra_percent,
                            "threshold_amount": contract_values.threshold_amount,
                            "threshold_recurring_extra_amount": contract_values.threshold_recurring_extra_amount,
                            "threshold_recurring_extra_percent": contract_values.threshold_recurring_extra_percent,
                        }

                        this.deferred_continue_edit = contract_values.deferred_continue;

                        this.contractData.old_recurring_amount_with_fee = this.contractData.recurring_amount + this.calculate_transaction_fee(this.contractData.recurring_amount);

                        this.contractData.new_recurring_amount_with_fee = contract_values.recurring_amount + this.calculate_transaction_fee(contract_values.recurring_amount);

                        this.contractData.old_upfront_with_fee = contract_values.original_upfront_amount + this.calculate_transaction_fee(contract_values.original_upfront_amount);
                        this.contractData.new_upfront_with_fee = contract_values.new_upfront_amount + this.calculate_transaction_fee(contract_values.new_upfront_amount);

                        //Check this before activating edit contract for business - which upfront to display new upfront(which also includes adjusted upfront if any) or new upfront (without adjustement amount if any)
                        // this.contractData.new_upfront_with_fee = (contract_values.original_upfront_amount + contract_values.pending_upfront_amount) + this.calculate_transaction_fee((contract_values.original_upfront_amount + contract_values.pending_upfront_amount));

                        this.contractData.net_remaining_upfront_fee = contract_values.pending_upfront_amount > 0 ? contract_values.pending_upfront_amount + this.calculate_transaction_fee(contract_values.pending_upfront_amount) : 0;
                        this.contractData.remaining_upfront_transaction_fee = contract_values.pending_upfront_amount > 0 ? Number(this.calculate_transaction_fee(contract_values.pending_upfront_amount).toFixed(2)) : 0;

                        this.edit_contract_step = 4;
                    })
                    .catch(err => this.mainService.customPopups(err, 1));


            } else {
                this.edit_contract_data['treatment_amount'] = parseFloat(this.edit_contract_data['treatment_amount']);
                if (!this.edit_contract_data['treatment_amount']) {
                    this.mainService.customPopups('Please enter a valid finance amount', 1);
                    return;
                }
                this.setRecurringDataForEditContract();
            }
        } else if (this.edit_contract_step === 2) {
            if (!this.plan_array || this.plan_array.length == 0) {
                return;
            }
            if (!this.edit_contract_data['tenure'] && !this.edit_contract_data['new_recurring_amount']) {
                this.mainService.customPopups('Please enter a valid new tenure or recurring amount', 1);
                return;
            }
            if (this.edit_contract_data['tenure']) {
                if (!this.edit_contract_data['new_recurring_amount']) {
                    var maximum_tenure = Math.max.apply(Math, this.plan_array.map(item => item.month));
                    var minimum_tenure = Math.min.apply(Math, this.plan_array.map(item => item.month));
                    if (this.edit_contract_data['tenure'] > maximum_tenure) {
                        this.mainService.customPopups('New tenure should be less than or equal to ' + maximum_tenure + ' months', 1);
                        return;
                    }
                    if (this.edit_contract_data['tenure'] < minimum_tenure) {
                        this.mainService.customPopups('New tenure should be greater than or equal to ' + minimum_tenure + ' months', 1);
                        return;
                    }
                }
            }
            if (this.edit_contract_data['tenure'] && this.edit_contract_data['new_recurring_amount']) {
                this.getEditFinanceCompareV2();
            }
            if (!this.edit_contract_data['tenure']) {
                var max_recurring = Math.max.apply(Math, this.plan_array.map(item => item.new_recurring_amount_with_fee));
                var min_recurring = Math.min.apply(Math, this.plan_array.map(item => item.new_recurring_amount_with_fee));
                if (this.edit_contract_data['new_recurring_amount'] > max_recurring) {
                    this.mainService.customPopups('New recurring amount should be less than or equal to $' + max_recurring, 1);
                    return;
                }
                if (this.edit_contract_data['new_recurring_amount'] < min_recurring) {
                    this.mainService.customPopups('New recurring amount should be greater than or equal to $' + min_recurring, 1);
                    return;
                }
                this.getNearestPlan(this.edit_contract_data['new_recurring_amount']);
            }
        } else if (this.edit_contract_step === 4) {
            if (this.contract_types_new_edit.includes(this.contractData.contract_type)) {
                if (this.contract_values_v5.pending_upfront_amount > 0) {
                    this.edit_contract_step = this.edit_contract_step + 1;
                } else {
                    this.edit_contract_step = this.edit_contract_step + 2;
                }
                return
            } else {
                if (this.edit_contract_data['newFinanceDetails'].advance_interest_amount > this.edit_contract_data['oldFinanceDetails'].advance_interest_amount) {
                    this.edit_contract_step = this.edit_contract_step + 1;
                    return false;
                } else {
                    this.edit_contract_step = this.edit_contract_step + 2;
                    return false;
                }
            }
        } else if (this.edit_contract_step === 5) {
            if (!this.payment_option.paymentType) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 1 && !(this.selected_option == 1 || this.selected_option == 4 || this.selected_option == 5)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.payment_option.paymentType == 2 && !(this.selected_option == 2 || this.selected_option == 3)) {
                this.mainService.customPopups('Please select a valid option', 1);
                return;
            }
            if (this.selected_option == 2 || this.selected_option == 4) {
                this.createStripeTokenV2('edit_contract');
            } else {
                this.edit_contract_step = 6;
                return;
            }
        } else if (this.edit_contract_step == 9) {
            this.addEditBreakDown();
        }
        // 4 is final step and 5 is for retry
        if (this.edit_contract_step == 6 || this.edit_contract_step == 7) {
            //cutomer payment
            if (this.contract_types_new_edit.includes(this.contractData.contract_type) && this.contractData.net_remaining_upfront_fee == 0) {
                this.goToEditContract(null, null);
            } else {
                if (this.edit_contract_data['newFinanceDetails'].advance_interest_amount > this.edit_contract_data['oldFinanceDetails'].advance_interest_amount) {
                    if (this.payment_option.paymentType == 1) {
                        //customer default card
                        if (this.selected_option == 1) {
                            // if (!this.edit_contract_data.selected_card) {
                                this.edit_contract_data.selected_card = this.changePaymentDateCard.source_id
                            // }
                            this.goToEditContract('patient_old_card', this.edit_contract_data.selected_card);
                        }
                        //customer new card
                        if (this.selected_option == 4) {
                            this.goToEditContract('patient_new_card', this.editContractStripeData['id']);
                        }
                        //customer default bank
                        if (this.selected_option == 5) {
                            this.goToEditContract('patient_old_bank', null);
                        }
                    }
                    //business payment
                    if (this.payment_option.paymentType == 2) {
                        //business default bank
                        if (this.selected_option == 3) {
                            this.goToEditContract('doctor_bank', null);
                        }
                        //business new card
                        if (this.selected_option == 2) {
                            this.goToEditContract('doctor_new_card', this.editContractStripeData['id']);
                        }

                    }
                } else {
                    this.goToEditContract(null, null);
                }
            }
        }
    }
    addEditBreakDown() {
        this.services();
        const validation = this.serviceBreakDown.every(item => item.service && item.price >= 0);
        if (!validation) {
            this.mainService.customPopups('Price breakdown is incomplete.', 1);
            return false;
        }
        if (this.totalServAmt != this.data.send_data.service_cost) {
            this.mainService.customPopups('Service breakdown amount does not matched with your service amount.', 1);
            return false;
        }
        let data = {
            access_token: localStorage.getItem('token'),
            contract_id: this.contract_id,
            contract_service_record: this.serviceBreakDown
        };
        this.mainService.api(data, 'update_contract_service_record', false)
            .subscribe((data: any) => {
                if (!data.is_error) {
                    if (this.data.type == 48) {
                        this.edit_contract_step = 7;
                    } else {
                        this.dialogRef.close({
                            'result': 2,
                            'service_added': this.serviceBreakDown
                        });
                    }
                } else {
                    this.mainService.customPopups(data.err, 1);
                }
            });
    }

    CalculateNewRecurringAmount = function () {
        if (!this.edit_contract_data.tenure) {
            this.edit_contract_data.new_recurring_amount = null;
            return;
        }
        let matched_data = this.plan_array.filter(plan => this.edit_contract_data.tenure == plan.month);
        if (matched_data && matched_data.length > 0) {
            this.edit_contract_data.new_recurring_amount = (Number(matched_data[0].new_recurring_amount_with_fee) + ((this.contractData.credit_reporting_status > 0 && this.contractData.credit_reporting_fee > 0) ? Number(this.contractData.credit_reporting_fee) : 0)).toFixed(2);
            this.edit_contract_data.new_recurring_amount_crf = (Number(matched_data[0].new_recurring_amount_with_fee) + ((this.contractData.credit_reporting_status > 0 && this.contractData.credit_reporting_fee > 0) ? Number(this.contractData.credit_reporting_fee) : 0)).toFixed(2);
            this.edit_contract_data.advance_interest_amount = matched_data[0].advance_interest_amount;
            this.contractData.new_recurring_amount = matched_data[0].recurring_amount;
            this.contractData.new_recurring_amount_with_fee = matched_data[0].new_recurring_amount_with_fee;
            this.contractData.remaining_upfront_transaction_fee = matched_data[0].remaining_upfront_transaction_fee;
            this.contractData.new_upfront_with_fee = matched_data[0].new_upfront_with_fee;
            this.contractData.net_remaining_upfront_fee = matched_data[0].net_remaining_upfront_fee;
            this.contractData.old_upfront_with_fee = matched_data[0].old_upfront_with_fee;
            this.contractData.new_interest_rate = matched_data[0].interest_rate;
            this.contractData.new_interest_rate_to_show = matched_data[0].interest_rate_to_show
        } else {
            this.edit_contract_data.new_recurring_amount = null;
        }
    }

    getNearestPlan(goal) {
        if (this.edit_contract_data.tenure) {
            return;
        }
        let nearest_rec_amount = this.plan_array.reduce(function (prev, curr) {
            return (Math.abs(curr.new_recurring_amount_with_fee - goal) < Math.abs(prev.new_recurring_amount_with_fee - goal) ? curr : prev);
        }).new_recurring_amount_with_fee;
        this.plan_array.forEach(item => {
            if (item.new_recurring_amount_with_fee == nearest_rec_amount) {
                this.edit_contract_data.tenure = item.month;
                this.edit_contract_data.advance_interest_amount = item.advance_interest_amount;
                this.edit_contract_data.new_recurring_amount = Number(nearest_rec_amount);
                this.contractData.new_recurring_amount = item.recurring_amount;
                this.contractData.new_recurring_amount_with_fee = item.new_recurring_amount_with_fee;
                this.contractData.remaining_upfront_transaction_fee = item.remaining_upfront_transaction_fee;
                this.contractData.new_upfront_with_fee = item.new_upfront_with_fee;
                this.contractData.net_remaining_upfront_fee = item.net_remaining_upfront_fee;
                this.contractData.old_upfront_with_fee = item.old_upfront_with_fee;
                this.contractData.new_interest_rate = item.interest_rate;
                this.contractData.new_interest_rate_to_show = item.interest_rate_to_show
            }
        })
    }

    setEditContractData(data) {
        this.payment_option = {
            cardName: null,
            paymentType: null,
            terms: null
        };
        this.contractData = data.send_data;
        this.edit_contract_data.minimum_amount = this.contractData.financeSettings && this.contractData.financeSettings.minimum_amount || 0;
        this.edit_contract_data.maximum_amount = this.contractData.financeSettings && this.contractData.financeSettings.maximum_amount || 1000000;
        this.edit_contract_data.maximum_tenure = this.contractData.financeSettings && this.contractData.financeSettings.maximum_tenure || 99;
        this.edit_contract_data.minimum_tenure = this.contractData.financeSettings && this.contractData.financeSettings.minimum_tenure || 1;
        // setTimeout(() => {
        //     // this.mainService.stripe_element.mount('#' + 'edit_contract');
        //     this.mountCard();
        // }, 1000);

        //Remove bank form bank array
        this.changePaymentDateCardList = this.contractData.payment_sources.filter((item, index) => {
            return item.payment_source !== "Bank"
        });
        let default_card = this.changePaymentDateCardList.filter(card => card.source_id == this.contractData.source_id);
        if (default_card && default_card[0]) {
            this.selPaymentCard(default_card[0], false);
        }
    }

    async mountCard(isFromBusiness) {
    this.stripe.UnmountStripe();
       setTimeout(async() => {
        let data = {
            isMountAddress: false,
          }
          if(isFromBusiness){
            data["doctor_id"] = this.data.send_data.doctor_id
          } else {
            data["patient_id"] = this.data.send_data.patient_id
          }
          await this.stripe.createStripeElement(data);
       }, 500);
      }


    goToEditContract(payment_type, stripe_token) {
        if (!this.edit_contract_data.notes || !this.edit_contract_data.notes.trim()) {
            this.mainService.customPopups('Please enter a valid reason.', 2);
            return;
        }
        if (!this.edit_contract_data.terms) {
            this.mainService.customPopups('Please accept Terms & Conditions.', 2);
            return;
        }
        var payment_mode = this.payment_option.paymentType || 0;
        if (payment_type == 'doctor_bank') {
            payment_mode = 3;
        }
        var params = {
            access_token: localStorage.getItem('token'),
            pf_id: this.contractData.pf_id,
            treatment_amount: this.edit_contract_data.treatment_amount,
            number_of_payments: this.edit_contract_data.tenure,
            recurring_amount: this.contractData.new_recurring_amount,
            notes: this.edit_contract_data.notes.trim(),
            payment_mode: payment_mode, //1 from patient's card 2 from doctor's card 3 from doctor's stripe
            source_id: this.contractData.source_id_new ? this.contractData.source_id_new : this.contractData.source_id,
            stripe_token: 0,
            seti_id: this.stripe && this.stripe.setup_intent_secret ? this.stripe.setup_intent_secret.setup_intent_id : null
        };

        if (params.payment_mode == 1 || params.payment_mode == 2) {
            if (payment_type == 'patient_new_card' || payment_type == 'doctor_new_card') {
                console.log("----------> Stripe Token", stripe_token);
                params.stripe_token = stripe_token;
                delete params.source_id;
            } else {
                delete params.stripe_token;
            }

        }
        if (params.payment_mode == 3) {
            delete params.source_id;
            delete params.stripe_token;
        }
        if (payment_type == 'patient_old_card') {
            params.source_id = stripe_token;
        }
        if (payment_type == 'patient_old_bank') {
            params.payment_mode = 4;
            params.source_id = this.contractData.plaidAccount && this.contractData.plaidAccount[0] && this.contractData.plaidAccount[0].source_id ? this.contractData.plaidAccount[0].source_id : 0;
        }

        if (this.contract_types_new_edit.includes(this.contractData.contract_type)) {
            this.newEditContract({
                notes: params.notes,
                payment_mode:
                    params.payment_mode,
                source_id: params.source_id,
                stripe_token: params.stripe_token || undefined,
                get_values: 0,
                ...this.new_edit_contract_values,
                ...this.contract_values_v5
            })
                .then(() => {
                    let services = this.contractData.service_record ? JSON.parse(JSON.stringify(this.contractData.service_record)) : [];
                    if (services && services.length > 0 && this.edit_contract_data.newFinanceDetails.treatment_amount != this.contractData.treatment_amount && params.payment_mode != 4) {
                        this.contractData.treatment_amount = this.edit_contract_data.newFinanceDetails.treatment_amount;
                        this.data.send_data.service_cost = this.contractData.treatment_amount
                        this.contract_id = this.contractData.contract_id;
                        this.serviceBreakDown = this.contractData.service_record;
                        this.totalServAmt = this.edit_contract_data.newFinanceDetails.treatment_amount;
                        this.edit_contract_step = 9;
                    } else {
                        this.edit_contract_step = 7;
                    }
                    this.send_email = this.contractData.patient_email;
                    if (this.contractData.patient_mobile && this.contractData.patient_mobile.includes('+1-')) {
                        this.send_phone = this.contractData.patient_mobile.substring(3);
                    } else {
                        this.send_phone = this.contractData.patient_mobile;
                    }
                })
                .catch(err => {
                    if (err && (err.includes('You cannot use a Stripe token more than once') || err == 'You cannot use a Stripe token more than once')) {
                        this.editContractResult.override_text = "Your card has been declined";
                        err = "Your card has been declined";
                    }
                    this.mainService.customPopups(err, 1);
                    return;
                });
        } else {
            this.mainService.api(params, 'edit_financing_details_doctor', true)
                .subscribe(async (data: any) => {
                    if (data.three_d_required) {
                        let result = await this.stripe.confirm3DSCharge(data.payment_intent.client_secret, data.payment_intent.payment_method);
                        if (!result) {
                            this.loaderService.hide();
                            return;
                        }
                    }
                    this.editContractResult = data;
                    if (data.is_error == 0) {
                        let services = this.contractData.service_record ? JSON.parse(JSON.stringify(this.contractData.service_record)) : [];
                        if (services && services.length > 0 && this.edit_contract_data.treatment_amount != this.contractData.treatment_amount && params.payment_mode != 4) {
                            this.contractData.treatment_amount = this.edit_contract_data.treatment_amount;
                            this.data.send_data.service_cost = this.contractData.treatment_amount
                            this.contract_id = this.contractData.contract_id;
                            this.serviceBreakDown = this.contractData.service_record;
                            this.totalServAmt = this.edit_contract_data.treatment_amount;
                            this.edit_contract_step = 9;
                        } else {
                            this.edit_contract_step = 7;
                        }
                        this.send_email = this.contractData.patient_email;
                        if (this.contractData.patient_mobile && this.contractData.patient_mobile.includes('+1-')) {
                            this.send_phone = this.contractData.patient_mobile.substring(3);
                        } else {
                            this.send_phone = this.contractData.patient_mobile;
                        }
                    }
                    if (data.is_error == 1) {
                        this.edit_contract_step = 7;
                        if (data.override_text) {
                            if (data.override_text.indexOf('You cannot use a Stripe token more than once') >= 0) {
                                this.editContractResult.override_text = "Your card has been declined";
                            } else {
                            }
                        } else { }
                    }
                }, (error: any) => {
                    console.log(error);
                });
        }
    }

    getEditFinanceCompareV2() {
        this.edit_contract_data.oldFinanceDetails = {
            "interest_rate": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
            "interest_rate_to_show": this.contractData.interest_rate_to_show || this.contractData.interest_rate,
            "number_of_payments": this.contractData.number_of_payments,
            "treatment_amount": this.contractData.treatment_amount,
            "financed_amount": this.contractData.financed_amount,
            "downpayment_amount": this.contractData.downpayment_amount,
            "recurring_amount": this.contractData.recurring_amount,
            "remaining_payments": this.contractData.remaining_payments,
            "advance_interest_amount": this.contractData.advance_interest_amount,
            "recurring_extra_amount": this.contractData.recurring_extra_amount,
            "recurring_extra_percent": this.contractData.recurring_extra_percent,
            "threshold_amount": this.contractData.threshold_amount,
            "threshold_recurring_extra_amount": this.contractData.threshold_recurring_extra_amount,
            "threshold_recurring_extra_percent": this.contractData.threshold_recurring_extra_percent
        }
        this.edit_contract_data.newFinanceDetails = {
            "interest_rate": this.contractData.new_interest_rate,
            "interest_rate_to_show": this.contractData.new_interest_rate_to_show,
            "number_of_payments": this.edit_contract_data.tenure,
            "treatment_amount": this.edit_contract_data.treatment_amount,
            "financed_amount": this.edit_contract_data.treatment_amount - this.contractData.downpayment_amount,
            "downpayment_amount": this.contractData.downpayment_amount,
            "recurring_amount": this.edit_contract_data.new_recurring_amount,
            "remaining_payments": this.edit_contract_data.tenure - (this.contractData.number_of_payments - this.contractData.remaining_payments),
            "advance_interest_amount": this.edit_contract_data.advance_interest_amount,
            "recurring_extra_amount": this.contractData.recurring_extra_amount,
            "recurring_extra_percent": this.contractData.recurring_extra_percent,
            "threshold_amount": this.contractData.threshold_amount,
            "threshold_recurring_extra_amount": this.contractData.threshold_recurring_extra_amount,
            "threshold_recurring_extra_percent": this.contractData.threshold_recurring_extra_percent
        }
        if (!this.edit_contract_data.newFinanceDetails.advance_interest_amount) {
            this.edit_contract_data.newFinanceDetails.advance_interest_amount = 0;
        }
        if (!this.edit_contract_data.oldFinanceDetails.advance_interest_amount) {
            this.edit_contract_data.oldFinanceDetails.advance_interest_amount = 0;
        }
        this.edit_contract_step = 4;
    }

    setRecurringDataForEditContract() {
        var data = {
            access_token: localStorage.getItem('token'),
            pf_id: this.contractData.pf_id,
            treatment_amount: parseFloat(this.edit_contract_data.treatment_amount)
        }
        this.mainService.api(data, 'get_edit_finance_plans', true)
            .subscribe((data: any) => {
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text || data.err, 1);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.plan_array = data.months;
                    this.contractData.old_recurring_amount_with_fee = this.plan_array[0].old_recurring_amount_with_fee;
                    this.contractData.upfront_without_interest = this.plan_array[0].upfront_without_interest;
                    this.edit_contract_data.new_recurring_amount = null;
                    this.edit_contract_data.tenure = null;
                    this.edit_contract_step = 2;
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    public confirmAction() {
        this.dialogRef.close(1);
    }

    goTo(path) {
        this.router.navigate([path]);
        this.dialogRef.close();
    }

    paymentChargeFee() {
        this.dialog.open(SimpleDialogComponent, {
            width: '650px',
            panelClass: 'simpleDialog',
            data: {
                type: 30,
                title: 'How to Change Payment Dates'
            }
        });
    }
    public getTransactionFee(contract, comparable_value) {
        comparable_value = parseFloat(comparable_value);
        contract.recurring_extra_amount = parseFloat(contract.recurring_extra_amount);
        contract.recurring_extra_percent = parseFloat(contract.recurring_extra_percent);
        contract.threshold_amount = parseFloat(contract.threshold_amount);
        contract.threshold_recurring_extra_amount = parseFloat(contract.threshold_recurring_extra_amount);
        contract.threshold_recurring_extra_percent = parseFloat(contract.threshold_recurring_extra_percent);
        let text = '';
        if (comparable_value < contract.threshold_amount) {
            if (contract.recurring_extra_percent) {
                text += `${parseFloat(contract.recurring_extra_percent).toFixed(2)}%`
            }
            if (contract.recurring_extra_amount && contract.recurring_extra_percent) {
                text += ' + ';
            }
            if (contract.recurring_extra_amount) {
                text += `$${parseFloat(contract.recurring_extra_amount).toFixed(2)}`
            }
        } else {
            if (contract.threshold_recurring_extra_percent) {
                text += `${parseFloat(contract.threshold_recurring_extra_percent).toFixed(2)}%`
            }
            if (contract.threshold_recurring_extra_amount && contract.threshold_recurring_extra_percent) {
                text += ' + ';
            }
            if (contract.threshold_recurring_extra_amount) {
                text += `$${parseFloat(contract.threshold_recurring_extra_amount).toFixed(2)}`
            }
        }
        return text;
    }
    services() {
        this.totalServAmt = this.serviceBreakDown.map(o => o.price).reduce((a, c) => { return Number(a) + Number(c) }, 0);
    };

    /* Service Breakdown */
    deleteBreakdown(deleted_index) {
        this.serviceBreakDown = this.serviceBreakDown.filter((item, index, data) => {
            return deleted_index !== index
        })
        this.services();
        this.addFocus('breakDownVal' + (this.serviceBreakDown.length - 1) + '')
    }

    addBreakdown() {
        let validation = this.serviceBreakDown.every(item => item.service.trim() && item.price != null);
        if (validation) {
            this.serviceBreakDown.push({
                service: '',
                price: null
            });
            this.services();
            this.addFocus('breakDownText' + (this.serviceBreakDown.length - 1) + '')
        } else {
            this.mainService.customPopups('Price breakdown is incomplete.', 1);
        }
    }

    addFocus(d) {
        setTimeout(() => {
            document.getElementById(d).focus();
        }, 200);
    }
    enterNumberOnly(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    customerMinor = 0;
    customerDob: string;
    zipPostalCode: any;
    empZipCode: any;
    zipLocCode: number;
    step = 1;
    salutationOptions: any = [
        {
            'label': 'None',
            'value': ''
        },
        {
            'label': 'Dr.',
            'value': 'Dr.'
        },
        {
            'label': 'Mr.',
            'value': 'Mr.'
        },
        {
            'label': 'Ms.',
            'value': 'Ms.'
        },
        {
            'label': 'Mrs.',
            'value': 'Mrs.'
        },
        {
            'label': 'Miss.',
            'value': 'Miss.'
        }
    ];

    guardianSalutation = this.salutationOptions[0];
    customerSalutation = this.salutationOptions[0];

    customerInfo: any = [];
    customerDetails = this._formBuilder.group({
        'guardianSalutation': [''],
        'guardianFirstName': [''],
        'guardianLastName': [''],
        'customerMinor': ['', Validators.required],
        'gender': ['', Validators.required],
        'customerSalutation': [''],
        'customerFirstName': ['', [Validators.required]],
        'customerLastName': ['', [Validators.required]],
        'customerDob': ['', Validators.required],
        'socailSecuityNumber': ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern(Regex.Name_1)]],
        'phoneNumber': ['', Validators.required],
        'emailAddress': ['', Validators.required],
        'dlNumber': ['', (this.doctorSettings && this.doctorSettings.is_DL_mandatory) ? Validators.required : ''],
        'address': ['', Validators.required],
        'employed': ['', Validators.required],
        'zipPostalCode': ['', Validators.required],
        'state': [{ value: "", disabled: true }],
        'city': [{ value: "", disabled: false }],
        'empName': [''],
        'empPhoneNumber': [''],
        'empZipCode': [''],
        'empAddress': [''],
        'empState': [{ value: "", disabled: true }],
        'empCity': [{ value: "", disabled: false }],
        'empAnnualIncome': [''],
        'document': [''],
        "office_address": [''],
        "office_state": [{ value: '', disabled: true }],
        "office_zip": [''],
        "office_city": [{ value: "", disabled: false }],
        "office_city_id": [''],
        "check_office": false
    });
    public getContractDetails(contractId) {
        const data = {
            access_token: localStorage.getItem('token'),
            contract_id: contractId,
            doctor_id: this.data.send_data.doctor_id
        }
        this.mainService.api(data, `patient_details`, true)
            .subscribe(response => {
                this.customerInfo = response.contract_info;
                this.zipPostalCode = response.contract_info[0].zip;
                this.empZipCode = response.contract_info[0].employer_zip;
                this.zipCode.city_id = response.contract_info[0].city_id;
                this.empZipCodeData.city_id = response.contract_info[0].employer_city_id;
                if (response.is_error) {
                    this.router.navigate(['/app/contract/list']);
                } else {
                    let dob = null;
                    if (response.contract_info[0].date_of_birth) {
                        const dobString = response.contract_info[0].date_of_birth;
                        let dateParts;
                        if (dobString.includes('-')) {
                            dateParts = dobString.split('T')[0].split('-');
                        } else if (dobString.includes('/')) {
                            dateParts = dobString.split('/');
                        }

                        if (dateParts && dateParts.length === 3) {
                            const [part1, part2, part3] = dateParts;
                            const year = part1.length === 4 ? part1 : part3;
                            const month = part1.length === 4 ? part2 : part1;
                            const day = part1.length === 4 ? part3 : part2;
                            const dateOfBirth = new Date(year, month - 1, day);
                            if (!isNaN(dateOfBirth.getTime())) {
                                const formattedMonth = String(dateOfBirth.getMonth() + 1).padStart(2, '0');
                                const formattedDay = String(dateOfBirth.getDate()).padStart(2, '0');
                                const formattedYear = dateOfBirth.getFullYear();
                                dob = `${formattedMonth}/${formattedDay}/${formattedYear}`;
                            }
                        }
                    }



                    this.customerDetails.setValue({
                        'guardianSalutation': response.contract_info[0].guardian_title,
                        'guardianFirstName': response.contract_info[0].guardian_first_name,
                        'guardianLastName': response.contract_info[0].guardian_last_name,
                        'customerMinor': response.contract_info[0].is_minor,
                        'gender': response.contract_info[0].patient_gender || '',
                        'customerSalutation': response.contract_info[0].title,
                        'customerFirstName': response.contract_info[0].patient_first_name,
                        'customerLastName': response.contract_info[0].patient_last_name,
                        'customerDob': dob,
                        'socailSecuityNumber': response.contract_info[0].patient_ssn ? ('*****' + response.contract_info[0].patient_ssn.substring(response.contract_info[0].patient_ssn.length - 4)) : '',
                        'phoneNumber': response.contract_info[0].patient_mobile ? response.contract_info[0].patient_mobile.replace(/(.*)-/, "") : '',
                        'emailAddress': response.contract_info[0].patient_email,
                        'dlNumber': response.contract_info[0].dl_number,
                        'address': response.contract_info[0].patient_address,
                        'zipPostalCode': response.contract_info[0].zip,
                        'state': response.contract_info[0].state_name,
                        'city': response.contract_info[0].city,
                        'employed': this.checkuserEmployed(),
                        'empName': response.contract_info[0].employer_name,
                        'empPhoneNumber': response.contract_info[0].employer_mobile ? response.contract_info[0].employer_mobile.replace(/(.*)-/, "") : '',
                        'empZipCode': response.contract_info[0].employer_zip,
                        'empAddress': response.contract_info[0].employer_address,
                        'empState': response.contract_info[0].employer_state,
                        'empCity': response.contract_info[0].employer_city,
                        'empAnnualIncome': response.contract_info[0].annual_income,
                        'document': response.contract_info[0].dl_doc,
                        "office_address": response.contract_info[0].office_address || '',
                        "office_state": response.contract_info[0].office_state || '',
                        "office_zip": response.contract_info[0].office_zip || '',
                        "office_city": response.contract_info[0].office_city || '',
                        "office_city_id": response.contract_info[0].office_city_id || '',
                        "check_office": false
                    });

                    if (response && response.contract_info[0] && response.contract_info[0].office_city_id == response.contract_info[0].city_id) {
                        this.SameAddress = true
                    } else {
                        this.SameAddress = false
                    }
                    this.customerDetails.controls.emailAddress.disable()
                    if (response.contract_info[0].patient_ssn) {
                        this.customerDetails.controls.socailSecuityNumber.disable()
                    }
                    if (dob) {
                        this.customerDob = dob;
                        this.customerDetails.controls.customerDob.disable()
                    }
                    if (response.contract_info[0].zip) {
                        this.zipCode = {
                            city_id: response.contract_info[0].city_id,
                            zip: response.contract_info[0].zip,
                            state_name: response.contract_info[0].state_name,
                            city: response.contract_info[0].city
                        };
                    }
                    if (response.contract_info[0].employer_zip) {
                        this.empZipCodeData = {
                            city_id: response.contract_info[0].employer_city_id,
                            zip: response.contract_info[0].employer_zip,
                            state_name: response.contract_info[0].employer_state,
                            city: response.contract_info[0].employer_city
                        };
                    }

                    let employment = this.checkuserEmployed();
                    response.contract_info[0].employed = employment || '';
                    if ((response.contract_info[0].employed || this.checkuserEmployed() !== '') && response.contract_info[0].contract_type != 5) {
                        this.changeFeilds(employment);
                    }
                }
            });
    }

    /* Get Zip Code */
    zipCode: any = {
        city_id: '',
    };
    zip_data: any
    getZipselected(zipObj) {
        // if (zipObj && zipObj.city_id) {
        //     this.customerDetails.get('city').disable()
        // } else {
        //     this.customerDetails && this.customerDetails.get('city') && this.customerDetails.get('city').enable()
        // }
        try {
        if(this.data.type == 56) {
          this.zip_data = zipObj
            if (zipObj === '') {
              this.zipPostalCode = ''
              this.businessStripeDetailsForm.controls.zipPostalCode.setValue('');
              this.businessStripeDetailsForm.controls.city.setValue('');
              this.businessStripeDetailsForm.controls.state.setValue('');
              this.businessStripeDetailsForm.markAsDirty()
            }
            else {
              this.zipCode = zipObj;
              this.zipPostalCode = this.zipCode.zip
              this.businessStripeDetailsForm.controls.zipPostalCode.setValue(this.zipCode.zip);
              this.businessStripeDetailsForm.controls.state.setValue(this.zipCode.state_name);
              this.businessStripeDetailsForm.controls.city.setValue(this.zipCode.city);
              this.getZipCode(zipObj, 'user_data')
              this.businessStripeDetailsForm.markAsDirty()
            }
        } else {

          this.zip_data = zipObj
            if (zipObj === '') {
              this.zipPostalCode = ''
              this.customerDetails.controls.zipPostalCode.setValue('');
              this.customerDetails.controls.city.setValue('');
              this.customerDetails.controls.state.setValue('');
              this.customerDetails.markAsDirty()
            }
            else {
              this.zipCode = zipObj;
              this.zipPostalCode = this.zipCode.zip
              this.customerDetails.controls.zipPostalCode.setValue(this.zipCode.zip);
              this.customerDetails.controls.state.setValue(this.zipCode.state_name);
              this.customerDetails.controls.city.setValue(this.zipCode.city);
              this.customerDetails.markAsDirty()
            }
          }
          } catch (err) {
            console.log(err)
          }
    }

    /* Get Emp Zip Code */
    empZipCodeData: any = {
        city_id: ''
    };
    getEmpZipselected(zipObj) {
        // if (zipObj && zipObj.city_id) {
        //     this.customerDetails.get('empCity').disable()
        // } else {
        //     this.customerDetails && this.customerDetails.get('empCity') && this.customerDetails.get('empCity').enable()
        // }
        if (zipObj == '') {
            this.empZipCode = ''
            this.customerDetails.controls.empZipCode.setValue('');
            this.customerDetails.controls.empState.setValue('');
            this.customerDetails.controls.empCity.setValue('');

        } else {
            this.empZipCode = zipObj.zip
            this.empZipCodeData = zipObj;
            this.customerDetails.controls.empZipCode.setValue(zipObj.zip);
            this.customerDetails.controls.empState.setValue(zipObj.state_name);
            this.customerDetails.controls.empCity.setValue(zipObj.city);
        }


    }
    office_cityy: any = ''
    getOfficeZipselected(zipObj) {
        if (zipObj) {
            // if (zipObj && zipObj.city_id) {
            //     this.customerDetails.get('office_city').disable()
            // } else {
            //     this.customerDetails && this.customerDetails.get('office_city') && this.customerDetails.get('office_city').enable()
            // }
            this.office_zipObj = zipObj;
            this.office_zip = zipObj.zip;
            this.office_cityy = zipObj.city
            this.customerDetails.controls.office_zip.setValue(this.office_zipObj.zip);
            this.customerDetails.controls.office_state.setValue(this.office_zipObj.state_name);
            this.customerDetails.controls.office_city.setValue(this.office_zipObj.city);
            if (this.office_zipObj && this.office_zipObj.city_id)
                this.customerDetails.controls.office_city_id.setValue(this.office_zipObj.city_id);
        } else {
            this.office_cityy = ''
            this.office_zip = '';
            this.customerDetails.controls.office_zip.setValue('');
            this.customerDetails.controls.office_state.setValue('');
            this.customerDetails.controls.office_city.setValue('');
            this.customerDetails.controls.office_city_id.setValue('');
        }
        localStorage.setItem('retainOfficeZipCode', JSON.stringify(zipObj));
    }

    edit_customer_step = 2;
    timeoutCount:number=100
    customerDetailsSubmit() {
        if (this.customerDetails.controls && this.customerDetails.controls.payment_source_reference && this.customerDetails.value.payment_source != 'Others') {
            this.customerDetails.controls.payment_source_reference.clearValidators();
            this.customerDetails.controls.payment_source_reference.updateValueAndValidity();
        }

        if (this.data.send_data.contract_type == 5) {
            this.customerDetails.removeControl('empAnnualIncome');
            this.customerDetails.removeControl('employed');
            this.customerDetails.updateValueAndValidity();
        }
        if (this.customerDetails.invalid) {
            this.customerDetails.markAllAsTouched();
            this.customerDetails.markAsDirty();
            return;
        }
        if((this.customerDetails.controls.phoneNumber.value == this.phoneCovertor(this.userInfo[0].doctor_mobile)) || (this.customerDetails.controls.phoneNumber.value == this.phoneCovertor(this.userInfo[0].practice_mobile))){
            this.customerDetails.get("phoneNumber").setErrors({PhoneNumber:true})
            // this.mainService.customPopups('Customer Phone Number Cannot be same as Business Phone.', 1);
            return false;
        }

        if (this.customerDetails.controls && this.customerDetails.controls.empPhoneNumber && (this.customerDetails.controls.empPhoneNumber.value === this.phoneCovertor(this.userInfo[0].doctor_mobile) || this.customerDetails.controls.empPhoneNumber.value === this.phoneCovertor(this.userInfo[0].practice_mobile))) {
            this.customerDetails.get("empPhoneNumber").setErrors({empPhoneNumber:true})
            // this.mainService.customPopups('Customer Phone Number Cannot be same as Business Phone.', 1);
            return false;
        }
        if(this.data.send_data.contract_type != 5){
            if(this.customerDetails.value.employed == 2){

                if(((this.zipCode && this.zipCode.city_id) && (this.office_zipObj && this.office_zipObj.city_id))){
                    this.timeoutCount=100
                    this.edit_patient_profile()
                } else {
                    this.timeoutCount = 2000
                    if (this.zipCode && this.zipCode.city) {
                    } else {
                        this.zipCode['city'] = this.customerDetails.value.city ? this.customerDetails.value.city : ''
                    }
                    if (this.office_zipObj && this.office_zipObj.city) {
                    } else {
                        this.office_zipObj['city'] = this.customerDetails.value.city ? this.customerDetails.value.office_city : ''
                    }
                    const combin_data: any = {}
                    if (this.zipCode && this.zipCode.city_id) {
                    } else {
                        this.zipCode['city'] = this.customerDetails.value.city;
                        combin_data['user_data'] = {
                            addressObj: this.zipCode
                        }
                    }
                    if (this.office_zipObj && this.office_zipObj.city_id) {
                    } else {
                        this.office_zipObj['city'] = this.office_cityy
                        combin_data['office_data'] = {
                            addressObj: this.office_zipObj
                        }
                    }

                    this.add_address(combin_data)
                }


            } else if (this.customerDetails.value.employed == 0) {

                if (((this.zipCode && this.zipCode.city_id) && (this.empZipCodeData && this.empZipCodeData.city_id))) {
                    this.timeoutCount = 100
                    this.edit_patient_profile()
                } else {
                    this.timeoutCount = 2000
                    if (this.zipCode && this.zipCode.city) {
                    } else {
                        this.zipCode['city'] = this.customerDetails.value && this.customerDetails.value.city
                    }
                    if (this.empZipCodeData && this.empZipCodeData.city) {
                    } else {
                        this.empZipCodeData['city'] = this.customerDetails.value && this.customerDetails.value.empCity
                    }
                    const combin_data: any = {}
                    if (this.zipCode.city_id) {
                    } else {
                        combin_data['user_data'] = {
                            addressObj: this.zipCode
                        }
                    }
                    if (this.empZipCodeData.city_id) {
                    } else {
                        combin_data['employed_data'] = {
                            addressObj: this.empZipCodeData
                        }
                    }
                    this.zipCode['city'] = this.customerDetails.value && this.customerDetails.value.city
                    this.empZipCodeData['city'] = this.customerDetails.value && this.customerDetails.value.empCity
                    this.add_address(combin_data)
                }
            } else if (this.customerDetails.value.employed == 1) {
                this.timeoutCount = 100
                const combin_data: any = {}
                if (this.zipCode.city_id) {
                    this.edit_patient_profile()
                } else {
                    if (this.zipCode && this.zipCode.city) {
                    } else {
                        this.zipCode['city'] = this.customerDetails.value && this.customerDetails.value.city
                    }
                    combin_data['user_data'] = {
                        addressObj: this.zipCode
                    }
                    this.zipCode['city'] = this.customerDetails.value && this.customerDetails.value.city
                    this.add_address(combin_data)
                }

            }
        } else {
            const combin_data = {}
            if (this.zipCode.city_id) {
                this.edit_patient_profile();
            } else {
                this.zipCode['city'] = this.customerDetails.value && this.customerDetails.value.city
                combin_data['user_data'] = {
                    addressObj: this.zipCode
                }
                this.add_address(combin_data)
            }

        }

    }
    phoneCovertor(phonenumber) {
        if (!phonenumber) return;

        const usCountryCode = "+1-";
        const dash = "-";

        if (phonenumber.startsWith(usCountryCode)) {
          return phonenumber.substring(usCountryCode.length);
        }

        if (phonenumber.includes(dash)) {
          return phonenumber.split(dash).join('');
        }

        return phonenumber;
      }
    edit_patient_profile(){
        setTimeout(() => {
            if (this.customerDetails.invalid) {
                this.customerDetails.markAllAsTouched();
                this.customerDetails.markAsDirty();
                return;
            }

            if (this.customerDetails.value.empAnnualIncome == 0) {
                this.customerDetails.get('empAnnualIncome').setErrors({ err: "Please enter a valid annual income" })
                return
            }


            if (this.customerDetails.value.phoneNumber == '0000000000' || this.customerDetails.value.empPhoneNumber == '0000000000') {
                this.mainService.customPopups("Please enter valid phone number.", 1);
                return;
            }
            let date1 = this.getTodayDate(this.customerDetails.controls.customerDob.value);
            if (!date1) {
                this.mainService.warningText= 'Please enter valid date of birth';
                return;
            }
            const data = {
                access_token: localStorage.getItem('token'),
                is_minor: this.customerDetails.value.customerMinor,
                guardian_title: this.customerDetails.value.guardianSalutation,
                guardian_first_name: this.customerDetails.value.guardianFirstName,
                guardian_last_name: this.customerDetails.value.guardianLastName,
                patient_gender: this.customerDetails.value.gender,
                patient_email: this.customerInfo[0].patient_email,
                title: this.customerDetails.value.customerSalutation,
                patient_first_name: this.customerDetails.value.customerFirstName,
                patient_last_name: this.customerDetails.value.customerLastName,
                patient_mobile: this.customerDetails.value.phoneNumber,
                patient_address: this.customerDetails.value.address,
                date_of_birth: date1,
                patient_ssn: this.customerDetails.value.socailSecuityNumber,
                dl_number: this.customerDetails.value.dlNumber,
                city_id: this.zipCode.city_id,
                employer_name: this.customerDetails.value.empName,
                employer_mobile: this.customerDetails.value.empPhoneNumber,
                employer_address: this.customerDetails.value.empAddress,
                employer_city: this.empZipCodeData.city_id,
                annual_income: Number(this.customerDetails.value.empAnnualIncome),
                contract_id: this.data.send_data.contract_id,
                doctor_id: Number(this.data.send_data.doctor_id),
                patient_id: this.customerInfo[0].patient_id,
                pf_id: this.customerInfo[0].pf_id
            }
            if (this.customerInfo[0].patient_ssn) {
                data.patient_ssn = this.customerInfo[0].patient_ssn;
            }
            if (this.customerInfo[0].date_of_birth) {
                let dob1 = this.customerInfo[0].date_of_birth.split('-');
                if (dob1.length == 3) {
                    data.date_of_birth = `${dob1[2]}-${dob1[0]}-${dob1[1]}`;
                }
            }
            if (this.customerDetails.value.employed == 1) {
                data['payback_methods'] = this.customerDetails.controls.payment_source.value;
                if (this.customerDetails.controls.payment_source.value == 'Others') {
                    data['payback_methods'] = this.customerDetails.controls.payment_source_reference.value;
                }
            }
            if (this.customerDetails.value.employed == 2) {
                data['office_address'] = this.customerDetails.controls['office_address'].value;
                data['office_city_id'] = this.customerDetails.value.office_city_id;
                data['office_city'] = this.office_zipObj.city || "";
                data['office_state'] = this.office_zipObj.state_name || "";
                data['profession'] = this.customerDetails.value.profession;
                if (this.customerDetails.value.annual_income > 0) {
                    data['annual_income'] = this.customerDetails.value.annual_income;
                }
                else {
                    this.customerDetails.controls['annual_income'].setValue('')
                    this.customerDetails.controls['annual_income'].setValidators(Validators.required);
                    this.customerDetails.controls['annual_income'].updateValueAndValidity();
                    return;
                }
            }
            this.mainService.api(data, `edit_patient_profile`, false)
                .subscribe(response => {
                    if (response.is_error) {
                        this.mainService.customPopups(response.override_text || response.err, 1);
                    } else {
                        this.edit_customer_step = 3;
                    }
                });
        }, 100);

    }


    add_address(data: any, type?) {
        if (!data) {
        } else {
            this.mainService.api(data, `add_address`, false)
                .subscribe(response => {
                    if (!response.is_error) {
                        if (response && response.data) {
                            if (response && response.data && response.data.office_data && response.data.office_data[0]) {
                                this.office_zipObj = response && response.data && response.data.office_data && response.data.office_data[0]
                                this.getOfficeZipselected(this.office_zipObj)
                            }
                            if (response && response.data && response.data.user_data && response.data.user_data[0]) {
                                this.zipCode = response && response.data && response.data.office_data && response.data.user_data[0]
                                this.getZipselected(this.zipCode)
                            }
                            if (response && response.data && response.data.emp_data && response.data.emp_data[0]) {
                                this.empZipCodeData = response && response.data && response.data.office_data && response.data.emp_data[0]
                                this.getEmpZipselected(this.empZipCodeData)
                            }
                            this.edit_patient_profile()
                        }
                    } else {
                        console.log(response.override_text);
                    }
                });
        }
    }

    allowed_payback_methods = ALLOWED_PAYBACK_METHODS;
    changeFeilds(i) {
        try {
            this.customerDetails.get('employed').setValue(i);
            if (i == 0 || i == '0') {
                this.customerDetails.addControl('zipPostalCode', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].zip || ''));
                this.customerDetails.addControl('empZipCode', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_zip || ''));
                this.empZipCode = this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_zip ? this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_zip : ''
                this.customerDetails.controls.empZipCode.setValidators([Validators.required]);
                this.customerDetails.addControl('empName', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_name || ''));
                this.customerDetails.controls.empName.setValidators([Validators.required]);

                this.customerDetails.addControl('empPhoneNumber', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_mobile ? this.customerInfo[0] && this.customerInfo[0].employer_mobile.replace(/(.*)-/, "") : ''));
                this.customerDetails.controls.empPhoneNumber.setValidators([Validators.required]);

                this.customerDetails.addControl('empAddress', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_address || ''));
                this.customerDetails.controls.empAddress.setValidators([Validators.required]);

                this.customerDetails.addControl('empAnnualIncome', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].annual_income > 0 ? this.customerInfo[0].annual_income : ''));
                this.customerDetails.controls.empAnnualIncome.setValidators([Validators.required]);

                this.customerDetails.addControl('empState', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_state || ''));
                this.customerDetails.addControl('empCity', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].employer_city || ''));
                this.customerDetails.controls.empCity.setValidators([Validators.required]);

                // remove other controls
                if (this.customerDetails.controls.office_address !== undefined) {
                    this.customerDetails.removeControl('office_address');
                    this.customerDetails.removeControl('office_city');
                    this.customerDetails.removeControl('office_city_id');
                    this.customerDetails.removeControl('office_state');
                    this.customerDetails.removeControl('office_zip');
                    this.customerDetails.removeControl('profession');
                    this.customerDetails.removeControl('annual_income');
                    this.customerDetails.get('check_office').setValue(false);
                    this.office_zip = '';
                }
                else {
                    this.customerDetails.removeControl('payment_source');
                }

            }
            if (i == 1 || i == '1') {
                this.customerDetails.addControl('payment_source', this._formBuilder.control(this.allowed_payback_methods.includes(this.customerInfo[0].payback_methods) ? this.customerInfo[0].payback_methods : !this.customerInfo[0].payback_methods ? '' : 'Others', [Validators.required]));

                if (!this.allowed_payback_methods.includes(this.customerInfo[0].payback_methods)) {
                    this.customerDetails.addControl('payment_source_reference', this._formBuilder.control([]));
                    this.customerDetails.controls.payment_source.setValidators(Validators.required);
                    this.customerDetails.get('payment_source_reference').setValue(this.customerInfo[0].payback_methods);
                }

                if (this.customerDetails.controls.office_address !== undefined) {
                    this.customerDetails.removeControl('office_address');
                    this.customerDetails.removeControl('office_city');
                    this.customerDetails.removeControl('office_city_id');
                    this.customerDetails.removeControl('office_state');
                    this.customerDetails.removeControl('office_zip');
                    this.customerDetails.removeControl('profession');
                    this.customerDetails.removeControl('annual_income');
                    this.customerDetails.get('check_office').setValue(false);
                    this.office_zip = '';
                }
                if (this.customerDetails.controls.empAddress !== undefined) {
                    this.customerDetails.removeControl('empZipCode');
                    this.customerDetails.removeControl('empName');
                    this.customerDetails.removeControl('empPhoneNumber');
                    this.customerDetails.removeControl('empAddress');
                    this.customerDetails.removeControl('empAnnualIncome');
                }
            }
            if (i == 2 || i == '2') {
                this.customerDetails.addControl('office_address', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_address));
                this.customerDetails.controls.office_address.setValidators([Validators.required]);
                this.customerDetails.addControl('profession', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].profession));
                this.customerDetails.controls.profession.setValidators([Validators.required]);
                this.customerDetails.addControl('office_city', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_city));
                this.customerDetails.controls.office_city.setValidators([Validators.required]);
                this.customerDetails.addControl('office_city_id', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_city_id));
                this.customerDetails.addControl('office_state', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_state));
                this.customerDetails.controls.office_state.setValidators([Validators.required]);
                this.customerDetails.addControl('office_zip', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_zip));
                this.customerDetails.controls.office_zip.setValidators([Validators.required]);
                this.customerDetails.addControl('annual_income', this._formBuilder.control(this.customerInfo && this.customerInfo[0] && this.customerInfo[0].annual_income));
                if (this.customerDetails.value.annual_income == 0) {
                    this.customerDetails.get('annual_income').setValue('')
                }
                this.customerDetails.controls.annual_income.setValidators([Validators.required]);
                this.customerDetails.get('office_state').disable();
                let zip = {
                    zip: this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_zip,
                    state_name: this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_state,
                    city_id: this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_city_id,
                    city: this.customerInfo && this.customerInfo[0] && this.customerInfo[0].office_city
                }

                this.getOfficeZipselected(zip);

                // remove other controls
                if (this.customerDetails.controls.empAddress !== undefined) {
                    this.customerDetails.removeControl('empZipCode');
                    this.customerDetails.removeControl('empName');
                    this.customerDetails.removeControl('empPhoneNumber');
                    this.customerDetails.removeControl('empAddress');
                    this.customerDetails.removeControl('empAnnualIncome');
                    this.customerDetails.removeControl('empState');
                    this.customerDetails.removeControl('empCity');
                }
            }

            if (i === "1" || i === 1 || i === 2 || i === '2') {
                if (this.customerDetails.controls.empAddress !== undefined) {
                    this.customerDetails.removeControl('empZipCode');
                    this.customerDetails.removeControl('empName');
                    this.customerDetails.removeControl('empPhoneNumber');
                    this.customerDetails.removeControl('empAddress');
                    this.customerDetails.removeControl('empAnnualIncome');
                }
                if (i === 0 || i === '0' || i === '2' || i === 2) {
                    this.customerDetails.removeControl('payment_source')
                }
            }
            this.customerDetails.updateValueAndValidity();
        } catch (error) {
            console.log(error);
        }
    }

    changeSelection() {
        if (this.customerDetails.value.payment_source == 'Others') {
            this.customerDetails.addControl('payment_source_reference', this._formBuilder.control(this.allowed_payback_methods.includes(this.customerInfo[0].payback_methods) ? '' : this.customerInfo[0].payback_methods));
            this.customerDetails.controls.payment_source.setValidators(Validators.required);
        }

        let validator = [];

        if(this.businessStripeDetailsForm.value.businessType == "individual") {
          validator = [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern(Regex.Name_1), this.ssnValidator()];
        } else {
          validator = [Validators.required, this.einValidator()]
        }

        this.businessStripeDetailsForm.get('business_ein').clearValidators();
        this.businessStripeDetailsForm.get('business_ein').setValidators(validator);
        this.businessStripeDetailsForm.get('business_ein').setValue('');
        this.businessStripeDetailsForm.updateValueAndValidity();

        this.customerDetails.updateValueAndValidity()
    }

    getTodayDate(getDate) {
        let newDate;
        if (getDate.includes('/')) {
          newDate =getDate.replaceAll("/","");
        } else {
          newDate = getDate;
        }
        const value = newDate.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
        const todayDate =this.datepipe.transform(new Date(), 'yyyy-MM-dd');
        let date = moment(value);
        if (date.isValid()) {
            if (value > todayDate) {
                return false;
            }
            if (value >= '1900-01-01') {
                return value;
            } else {
                this.mainService.customPopups("Date of birth should be greater than 01/01/1900", 1);
                return;
            }
        } else {
            return false;
        }
    }


    addWpQuery() {
        if (!this.writeToUsMessage || this.writeToUsMessage == '' || !this.writeToUsMessage.trim() || this.writeToUsMessage.trim() == '') {
            this.mainService.customPopups('Please enter a message', 1);
            return false;
        }
        let user_info = getUserProfile();
        var firstName = user_info.enterprise_first_name ? user_info.enterprise_first_name : (user_info.agent_id ? user_info.agent_name : user_info.doctor_first_name);
        var lastName = user_info.enterprise_last_name ? user_info.enterprise_last_name : (user_info.agent_id ? "" : user_info.doctor_last_name);
        var userphonenumber = user_info.enterprise_mobile ? user_info.enterprise_mobile : (user_info.agent_id ? user_info.agent_mobile : user_info.doctor_mobile);
        var useremail = user_info.enterprise_email ? user_info.enterprise_email : (user_info.agent_id ? user_info.agent_email : user_info.doctor_email);
        if (user_info.role_id != 4) {
            let locations = getStoredLocations();
            let selected_location = locations.filter(element => element.doctor_id == this.data.send_data.doctor_id);
            firstName = selected_location[0].doctor_first_name;
            lastName = selected_location[0].doctor_last_name;
            userphonenumber = selected_location[0].doctor_mobile;
            useremail = selected_location[0].doctor_email;
        }
        var params = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.data.send_data.doctor_id,
            type: 1,
            name: firstName + " " + lastName,
            phone: userphonenumber,
            src_url: 'Inquiry made from Business Panel ' + window.location.href,
            message: this.writeToUsMessage,
            specialty: user_info.speciality_name ? user_info.speciality_name : 'N.A.',
            zip: user_info.zip ? user_info.zip : 'N.A.',
            address: user_info.practice_address ? user_info.practice_address : 'N.A.',
            email: useremail,
        }
        this.mainService.api(params, 'add_wp_contact_query', false, 'object')
            .subscribe(data => {
                if (data.is_error == 1) {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text || data.err, data.is_error);
                    } else {
                        this.mainService.flagPopUps(data.flag, data.is_error);
                    }
                } else {
                    this.mainService.customPopups('Message sent successfully', 0);
                    this.writeToUsMessage = '';
                    this.confirmAction();
                }
            })

    }

    placeOrder() {
        if (this.marketControls.invalid) {
            this.marketControls.markAllAsTouched();
            this.marketControls.markAsDirty();
            this.marketControls.markAsTouched();
            return;
        }
        else {
            this.dialogRef.close({ ...this.marketControls.value, city: this.marketControls.controls.city.value, state: this.marketControls.controls.state.value });
        }
    }
    public getZipselected_v2(zipObj) {
        // if (zipObj && zipObj.city_id) {
        //     this.marketControls.get('city').disable()
        // } else {
        //     this.marketControls.get('city').enable()
        // }
        if (zipObj !== '') {
            this.zipCode = zipObj;
            this.zipPostalCode = zipObj.zip;
            this.marketControls.controls.zipCode.setValue(zipObj.zip);
            this.marketControls.controls.city.setValue(zipObj.city);
            this.marketControls.controls.state.setValue(zipObj.state_name);
        }
        else {
            this.zipCode = '';
            this.zipPostalCode = ''
            // this.marketControls.get('city').disable()
            this.marketControls.controls.city.setValue('');
            this.marketControls.controls.state.setValue('');
            this.marketControls.controls.zipCode.setValue('');
            this.marketControls.controls.zipCode.markAllAsTouched();
            this.marketControls.controls.zipCode.markAsDirty();
            this.marketControls.controls.city.markAllAsTouched();
            this.marketControls.controls.city.markAsDirty();
            this.marketControls.controls.state.markAllAsTouched();
            this.marketControls.controls.state.markAsDirty();
            this.marketControls.updateValueAndValidity()
        }
    }

    reasonPrioritySet(d) {
        this.data.send_data.reason.forEach(element => {
            if (d == element.reason) {
                this.data.send_data.priority = element.priority;
            }
        });
    }

    /* Request Call back */
    requestCallBack(d) {
        this.is_allowed = this.mainService.subscription_global_setting(5)
        if (!this.is_allowed) {
            let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
                width: '600px',
                disableClose: true,
                panelClass: 'simpleDialog',
                data: {
                    type: 101,
                    title: '',
                    send_data: {
                        all_locations: this.all_locations,
                        close: this.dialogRef.close()
                    }
                }
            });
            confirmDialogRef.afterClosed().subscribe(result => {
                if (result) {
                    let temp = this.all_locations.filter(location => location.doctor_id == result)[0]
                    temp.id = temp.doctor_id;
                }
            });
        } else {
            var id = ''
            this.data.send_data.reason.forEach(element => {
                if (this.callReasonModel == element.reason) {
                    id = element.id;
                }
            });
            if (!d.value.timezone) {
                this.mainService.customPopups('Please Select Reason.', 1);
                return false;
            }
            if (!d.value.name || !d.value.name.trim()) {
                this.mainService.customPopups('Please enter a valid name.', 1);
                return false;
            }
            if (!d.value.phone) {
                this.mainService.customPopups('Please Enter a valid phone number.', 1);
                return false;
            }
            let mobile = d.value.phone.replace(/[^0-9]/g, "");
            if (mobile.length < 10) {
                this.mainService.customPopups('Please Enter a valid phone number.', 1);
                return false;
            } else if (mobile == '0000000000') {
                this.mainService.customPopups('Please Enter a valid phone number.', 1);
                return false;
            }
            if (!d.value.message || !d.value.message.trim()) {
                this.mainService.customPopups('Please Enter Message.', 1);
                return false;
            }
            let data = {
                access_token: localStorage.getItem('token'),
                message: d.value.message,
                enterprise_mobile: d.value.phone,
                doctor_mobile: d.value.phone,
                priority: d.value.priority,
                call_req_date: this.data.send_data.call_req_date,
                call_req_time: this.data.send_data.call_req_time,
                csr_req_tz: this.data.send_data.csr_req_tz,
                csr_req_tz_name: this.data.send_data.csr_req_tz_name,
                reason_id: id
            }
            this.mainService.api(data, 'add_csr_call_request_v2', true)
                .subscribe((data: any) => {
                    if (data.is_error == 0) {
                        this.dialogRef.close(1);
                    }
                });
        }
    }

    addInstantCard(form: NgForm) {
        this.new_address.cardError = "";
        if (form.valid) {
            const _this = this;
            this.loaderService.show();
            this.mainService.stripe.createToken(this.mainService.stripe_element, { currency: 'usd', name: form.value.cardholder_name }).then(response => {
                this.loaderService.hide();
                if (response && response.token && response.token.id) {
                    var data = {
                        access_token: localStorage.getItem('token'),
                        card_token: response.token.id,
                        doctor_id: this.data.send_data.doctor_id,
                        is_default: 1
                    }
                    this.editContractStripeData = response;
                    // save_card
                    this.mainService.api(data, 'add_instant_card', true)
                        .subscribe((data: any) => {
                            if (data.is_error == 1) {
                                if (data.override_text) {
                                    this.mainService.customPopups(data.override_text, 1);
                                } else {
                                    this.mainService.customPopups(data.flag, 1);
                                }
                            } else {
                                this.confirmAction();
                                if (this.data && this.data.action == 'Update') {
                                    this.mainService.customPopups('Card updated successfully.', 0);
                                } else {
                                    this.mainService.customPopups('Card added successfully.', 0);
                                }
                            }
                        }, (error: any) => {
                            console.log(error);
                        });
                } else {
                    _this.zone.run(_ => {
                        _this.new_address.cardError = response.error.message;
                    });
                }
            });
        }
    }

    /* */
    showSupportedDebitCard() {
        let data = {
            access_token: localStorage.getItem('token'),
            offset: 0,
            limit: 6000,
            search_string: '',
            doctor_id: this.data.send_data.doctor_id
        }
        this.mainService.api(data, 'instant_payout_support_bank_list', true)
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    this.data.type = 38;
                    this.getFilteredInstantPayoutSupoortBanks('');
                    this.banks = data.data;
                }
            });


    }

    searchDebitBank;
    banks = [];
    filtered_banks = [];
    getFilteredInstantPayoutSupoortBanks(search_string) {
        setTimeout(() => {
            let filtered_banks = this.banks.filter(bank => bank.card_name.toLowerCase().indexOf(search_string.trim().toLowerCase()) !== -1);
            this.filtered_banks = filtered_banks.slice(0, 100);
        }, 100);
    }
    bankDetailsForm: UntypedFormGroup;
    inItBankForm() {
        let userData = getUserProfile()

        this.bankDetailsForm = this.fb.group({
            'entityName': ['', [Validators.required, Validators.maxLength(22), Validators.minLength(2), Validators.pattern(/^(?=.*[a-zA-Z])[A-Za-z0-9 ]*$/)]],
            'routingNumber': ['', [Validators.required, Validators.maxLength(9)]],
            'confirmRoutingNumber': ['', [Validators.required, Validators.maxLength(10)]],
            'accountNumber': ['', [Validators.required, Validators.maxLength(15)]],
            'confirmAccountNumber': ['', [Validators.required, Validators.maxLength(15)]],
            // 'signatureField': ['', Validators.required],
            // 'terms': ['', Validators.required],
        }, {
            validator: [this.checkIfFieldsAreMatching('routingNumber', 'confirmRoutingNumber'), this.checkIfFieldsAreMatching('accountNumber', 'confirmAccountNumber')]
        });

        this.zip_data = {
          zip: userData.zip || '',
          state_name: userData.state_name || '',
          city_id: userData.city_id || '',
          city: userData.city || ''
        }

      this.businessStripeDetailsForm.patchValue({
        businessEmail: userData.practice_email || '',
        businessPhoneNumber: userData.practice_mobile.replace("+1-", '') || '',
        businessAddress: userData.practice_address || "",
        zipPostalCode: userData.zip || "",
        city: userData.city || "",
        state: userData.state_name,
        businessType: "",
        business_ein: "",
      });

    }

    otherDetailsForm: UntypedFormGroup;
    inItPracticeForm() {
        this.otherDetailsForm = this.fb.group({
            'businessModel': ['', [Validators.required, Validators.minLength(50), this.noTrailingSpaceValidator()]],
            'businessType': ['', [Validators.required]],
            'numberOfEmployees': ['', [Validators.required]],
            'practiceTenure': ['', [Validators.required]],
            'clientBase': ['', [Validators.required, Validators.minLength(20), this.noTrailingSpaceValidator()]],
            'crimeStatus': ['', [Validators.required]],
            'websiteUrl': [this.userInfo[0]['company_website'] || '', [Validators.pattern(Regex.URL_regex)]],
            // 'facebookUrl': ['', [Validators.pattern(Regex.URL_regex)]],
            // 'instagramUrl': ['', [Validators.pattern(Regex.URL_regex)]],
            // 'yelpUrl': ['', [Validators.pattern(Regex.URL_regex)]],
            // 'otherUrl': ['', [Validators.pattern(Regex.URL_regex)]],
            'customerFinancePerMonth': ['', [Validators.required]],
            // 'averageServiceAmount': ['', [Validators.required]],
            'minimumServiceAmount': ['', [Validators.required]],
            'maximumServiceAmount': ['', [Validators.required]],
            'crimeReason': [{ value: '', disabled: true }, []]
        }, {
            validator: []
        });
    }

    private checkIfFieldsAreMatching(originalKey: string, matchingKey: string) {
        return (group: UntypedFormGroup) => {
            let passwordInput = group.controls[originalKey],
                passwordConfirmationInput = group.controls[matchingKey];
            if (!passwordInput.value) {
                return passwordConfirmationInput.setErrors({ required: true });
            } else if (passwordInput.value != passwordConfirmationInput.value) {
                return passwordConfirmationInput.setErrors({ notEquivalent: true });
            } else {
                return passwordConfirmationInput.setErrors(null);
            }
        }
    }

    validateSSN(e) {
        if ((e.charCode >= 48 && e.charCode <= 57) || (e.charCode >= 65 && e.charCode <= 90) || (e.charCode >= 97 && e.charCode <= 122)) {
            return true;
        }
        return false;
    }

    toggleTerms() {
        const termsControl = this.bankDetailsForm.get('terms');
        termsControl.setValue(!termsControl.value);
      }

    public getStripeToken() {
        if(this.businessStripeDetailsForm.invalid || this.bankDetailsForm.invalid || this.consentForm.invalid) {
          this.checkCurrentForm(null, (this.currentStripeForm != 3 ? this.currentStripeForm+1 : this.currentStripeForm));
          return
        }

        if (this.bankDetailsForm.invalid) {
            this.bankDetailsForm.markAllAsTouched();
            this.bankDetailsForm.markAsDirty();
            return false;
        }
        if (this.consentForm.controls.signatureField.invalid) {
            this.mainService.customPopups('Please put your signature in the signature box.', 1);
            return false;
        }
        if (!this.consentForm.controls.terms.value) {
            return false;
        }
        this.loaderService.show()
        var stripeData = {
            country: 'US',
            currency: "USD",
            routing_number: this.bankDetailsForm.controls.routingNumber.value,
            account_number: this.bankDetailsForm.controls.accountNumber.value,
            account_holder_name: this.bankDetailsForm.controls.entityName.value,
            account_holder_type: this.businessStripeDetailsForm.value.businessType,
            // ein: this.businessStripeDetailsForm.value.business_ein,
        };
        this.loaderService.show();
        Stripe.bankAccount.createToken(stripeData, (status: any, response: any) => {
            this.loaderService.show();
            if (status == 400) {
                this.loaderService.hide();
                if (response.error.code == 'routing_number_invalid') {
                    this.mainService.customPopups('Invalid Routing Number', 1);
                } else if (response.error.code == 'account_number_invalid') {
                    this.mainService.customPopups('Invalid Account Number', 1);
                }
                this.loaderService.hide();
            } else if (status == 200) {
                this.loaderService.show();
                this.submitBank(response.id);
                this.loaderService.hide();
            }
        });
    }

    submitBank(stripeToken) {
      this.addingBank = true;
        var form = new FormData();
        form.append('access_token', localStorage.getItem('token'));
        form.append((this.businessStripeDetailsForm.value.businessType  == 'individual' ? 'tin' : 'business_tax_id'), this.businessStripeDetailsForm.controls.business_ein.value);
        form.append('business_type_id', this.businessStripeDetailsForm.value.businessType  == 'individual' ? '1' : '2');
        form.append('signature', this.consentForm.controls.signatureField.value);
        this.mainService.uploadApi(form, `add_registration_document`, true)
            .subscribe(response => {
                if (response.is_error) {
                    this.addingBank = false;
                    this.loaderService.hide();
                    return false;
                } else {
                    const data = {
                        access_token: localStorage.getItem('token'),
                        stripe_token: stripeToken,
                        practice_mobile: `+1-${this.businessStripeDetailsForm.controls.businessPhoneNumber.value}`,
                        practice_email: this.businessStripeDetailsForm.controls.businessEmail.value,
                        practice_address: this.businessStripeDetailsForm.value.businessAddress,
                        city_id: this.zipCode.city_id || this.zip_data.city_id,
                        business_type: this.businessStripeDetailsForm.value.businessType,
                    }

                    if(this.businessStripeDetailsForm.value.businessType == 'company')  {
                      data['business_type_id'] = 2;
                      data['business_tax_id'] = this.businessStripeDetailsForm.value.business_ein;
                      data['tin'] = this.businessStripeDetailsForm.value.business_ein;
                    }

                     if(this.businessStripeDetailsForm.value.businessType == 'individual')  {
                      data['business_type_id'] = 1;
                      data['business_tax_id'] = this.businessStripeDetailsForm.value.business_ein;
                      data['tin'] = this.businessStripeDetailsForm.value.business_ein;
                    }

                    this.mainService.api(data, `add_doctor_bank_v2`, true, 'object')
                        .subscribe(response => {
                          if (response.is_error) {
                                this.addingBank = false;
                                this.mainService.customPopups(response.err, 1);
                            } else {
                                this.addingBank = false;
                                this.mainService.customPopups('Bank added successfully', 0);
                                this.auth.showNextKYB = 1;
                                this.auth.accessTokenLogin();
                                // if (userSettings && userSettings.is_persona_required == 1) {
                                //     userProfileData[0].business_verification_state = 'bank_added';
                                // } else {
                                //     userProfileData[0].business_verification_state = 'persona_verified';
                                // // }
                                // localStorage.setItem('userProfileData', JSON.stringify(userProfileData));
                                // this._persona.openPersonaAddBankModal();
                            }
                        });
                }
            });
    }
    submitOtherDetails() {
        if (this.otherDetailsForm.invalid) {
            this.otherDetailsForm.markAllAsTouched();
            this.otherDetailsForm.markAsDirty();
            return false;
        }
        let data = {
            access_token: localStorage.getItem('token'),
            "practice_model": this.otherDetailsForm.controls.businessModel.value.trim(),
            "practice_type": this.otherDetailsForm.controls.businessType.value,
            "number_of_employee": this.otherDetailsForm.controls.numberOfEmployees.value,
            "practice_tenure": this.otherDetailsForm.controls.practiceTenure.value,
            "customer_enroll_per_month": this.otherDetailsForm.controls.customerFinancePerMonth.value,
            // "average_service_amount": this.otherDetailsForm.controls.averageServiceAmount.value,
            "minimum_service_amount": this.otherDetailsForm.controls.minimumServiceAmount.value,
            "maximum_service_amount": this.otherDetailsForm.controls.maximumServiceAmount.value,
            "practice_client_base": this.otherDetailsForm.controls.clientBase.value.trim(),
            "crime_status": this.otherDetailsForm.controls.crimeStatus.value == 'No' ? this.otherDetailsForm.controls.crimeStatus.value : this.otherDetailsForm.controls.crimeReason.value.trim(),
            "website_link": this.otherDetailsForm.controls.websiteUrl.value,
            // "facebook_link": this.otherDetailsForm.controls.facebookUrl.value,
            // "instagram_link": this.otherDetailsForm.controls.instagramUrl.value,
            // "yelp_link": this.otherDetailsForm.controls.yelpUrl.value,
            // "others_link": this.otherDetailsForm.controls.otherUrl.value,
        }
        if (!data.website_link) {
            this.mainService.customPopups('Please enter atleast one website or social media url', 1);
            return false;
        }
        if (data.customer_enroll_per_month == 0) {
            this.mainService.customPopups('Please enter a valid average customer financed per month', 1);
            return false;
        }
        // if (data.average_service_amount == 0) {
        //     this.mainService.customPopups('Please enter a valid average service amount', 1);
        //     return false;
        // }

        if (!data.minimum_service_amount || Number(data.minimum_service_amount) <= 0) {
            this.mainService.customPopups('Please enter a valid minimum service amount', 1);
            return false;
        }

        if (!data.maximum_service_amount || Number(data.maximum_service_amount) <= 0) {
            this.mainService.customPopups('Please enter a valid maximum service amount', 1);
            return false;
        }
        if (Number(data.minimum_service_amount) > Number(data.maximum_service_amount)) {
            this.mainService.customPopups('Minimum service amount should not be greater than maximum service amount', 1);
            return false;
        }
        if (data.website_link && data.website_link.trim().length > 0) {
            if (data.website_link.indexOf("http://") != 0 && data.website_link.indexOf("https://") != 0) {
                data.website_link = `https://${data.website_link}`;
            }
        }

        // if (data.facebook_link && data.facebook_link.trim().length > 0) {
        //     if (data.facebook_link.indexOf("http://") != 0 && data.facebook_link.indexOf("https://") != 0) {
        //         data.facebook_link = `https://${data.facebook_link}`;
        //     }
        // }

        // if (data.instagram_link && data.instagram_link.trim().length > 0) {
        //     if (data.instagram_link.indexOf("http://") != 0 && data.instagram_link.indexOf("https://") != 0) {
        //         data.instagram_link = `https://${data.instagram_link}`;
        //     }
        // }

        // if (data.yelp_link && data.yelp_link.trim().length > 0) {
        //     if (data.yelp_link.indexOf("http://") != 0 && data.yelp_link.indexOf("https://") != 0) {
        //         data.yelp_link = `https://${data.yelp_link}`;
        //     }
        // } if (data.others_link && data.others_link.trim().length > 0) {
        //     if (data.others_link.indexOf("http://") != 0 && data.others_link.indexOf("https://") != 0) {
        //         data.others_link = `https://${data.others_link}`;
        //     }
        // }
        this.mainService.api(data, 'update_business_info', false)
            .subscribe((data: any) => {
                if (data.is_error == 0) {
                    this.mainService.customPopups('Details updated successfully', 0);
                    this.dialog.closeAll();
                    this.auth.accessTokenLogin();
                    this.auth.getbankDetails();
                    var profile_subscriber_1 = this.auth.userProfileData$.subscribe(data => {
                        this.mainService.init();
                        profile_subscriber_1 && profile_subscriber_1.unsubscribe();
                    })
                } else {
                    if (data.override_text || data.err) {
                        this.mainService.customPopups(data.override_text, data.is_error);
                    } else {
                        this.mainService.customPopups(data.flag, data.is_error);
                    }
                }
            }, (error: any) => {
                console.log(error);
            });
    }

    @ViewChildren(SignatureNewComponent) public sigs: QueryList<SignatureNewComponent>;
    public clear() {
        this.sigs.first.clear();
    }

    crimeKey(key) {
        if (key == 1) {
            this.otherDetailsForm.controls.crimeReason.enable();
            this.otherDetailsForm.get('crimeReason').setValidators([Validators.required, this.noTrailingSpaceValidator()]);
            this.is_crime_reason = 1;
        } else {
            this.otherDetailsForm.controls.crimeReason.disable();
            this.otherDetailsForm.get('crimeReason').setValue(null);
            this.otherDetailsForm.get('crimeReason').clearValidators();
            this.is_crime_reason = 0;

        }
        this.otherDetailsForm.get('crimeReason').updateValueAndValidity();
        this.otherDetailsForm.updateValueAndValidity();
    }

    omit_special_char(event) {
        let k;
        k = event.charCode;  //k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    getLocZipselected(zipObj) {
        try {
            if (zipObj === '') {
                this.locationManageForm.controls.zip.setValue(null);
                this.locationManageForm.controls.city.setValue(null);
                this.locationManageForm.controls.state.setValue(null);
                this.locationManageForm.controls.cityId.setValue(null);
                this.locationManageForm.markAsDirty()
            }
            else {
                this.zipCode = zipObj.zip;
                this.locationManageForm.controls.zip.setValue(zipObj.zip);
                this.locationManageForm.controls.city.setValue(zipObj.city);
                this.locationManageForm.controls.state.setValue(zipObj.state_name);
                this.locationManageForm.controls.cityId.setValue(zipObj.city_id);
                this.locationManageForm.markAsDirty()
            }

        } catch (err) {
            console.log(err)
        }
    }


    initLocationDetailForm() {
        this.locationManageForm = this._formBuilder.group({
            'locationFirstName': ['', [Validators.required, Validators.maxLength(50), Validators.minLength(2)]],
            'locationLastName': ['', [Validators.required, Validators.maxLength(50), Validators.minLength(2)]],
            'emailAddress': ['', [Validators.required, Validators.email, Validators.pattern(Regex.email_regex)]],
            'phoneNumber': [''],
            'ind_id': ['', Validators.required],
            'sub_ind_id': ['', Validators.required],
            'cityId': '',
            'ind_name': [''],
            'sub_ind_name': ['']
        })
    }

    initPatchLocationValue() {
        this.locationManageForm.patchValue({
            locationFirstName: this.data.send_data.doctor_first_name,
            locationLastName: this.data.send_data.doctor_last_name,
            emailAddress: this.data.send_data.doctor_email,
            phoneNumber: this.data.send_data.doctor_mobile ? this.data.send_data.doctor_mobile.replace('+1-', '') : '',
        });
        this.zipLocCode = this.data.send_data.zip;
    }


    getIndustryList() {
      this.mainService.getIndustryList().subscribe((industries) => {
        this.industryList = industries;
      });
    }

    getSubIndustrylist(value) {
        if (value == "") {
            this.sub_industries = []
            return
        }
        let data = {
            ind_id: value,
            is_deleted: 0,
            is_verified: 1,
            full_data: 0,
        }

        this.mainService.api(data, 'get_all_sub_industries', false).subscribe((data) => {
            if (data && data.is_error == 0) {
                this.sub_industries = data.paignated_result;
                if (this.sub_industries[0]) {
                    this.locationManageForm.controls.sub_ind_id.setValue(this.sub_industries[0].doctor_speciality);
                } else {
                    this.locationManageForm.controls.sub_ind_id.setValue(9999);
                }
            }
            else {
                this.sub_industries = [];
                this.locationManageForm.controls.sub_ind_id.setValue(9999);
            }
        })
    }

    public submitLocation() {
        this.isLocationSubmitted = true;
        if (this.locationManageForm.invalid) {
          this.locationManageForm.markAllAsTouched();
            return false;
        }
        let data = {
            access_token: localStorage.getItem('token'),
            enterprise_id: this.profile.enterprise_id,
            doctor_first_name: this.locationManageForm.value.locationFirstName,
            doctor_last_name: this.locationManageForm.value.locationLastName,
            doctor_email: this.locationManageForm.value.emailAddress,
            ind_id: this.locationManageForm.controls.ind_id ? this.locationManageForm.value.ind_id : 9999,
            sub_ind_id: this.locationManageForm.controls.sub_ind_id ? this.locationManageForm.value.sub_ind_id : 9999,
            //   city_id: this.locationManageForm.value.cityId,
            device_type: environment.device_type,
            device_id: localStorage.getItem('user'),
            //   practice_address: this.locationManageForm.value.address,
            send_mail: 1,
            doctor_id: this.data.send_data && this.data.send_data.doctor_id ? this.data.send_data.doctor_id : ''
        }
        if (this.locationManageForm.controls.phoneNumber.value) {
            data['doctor_mobile'] = '';
            data['doctor_mobile'] = '+1-' + this.locationManageForm.controls.phoneNumber.value;
        }
        if (!this.isEdit) {
            if (this.locationManageForm.value.ind_id == 9999) {
                if (!this.locationManageForm.value.ind_name) {
                    this.mainService.customPopups('Please enter a valid name for industry', 1);
                    return false;
                }
                data['ind_name'] = this.locationManageForm.value.ind_name;
            }
            if (this.locationManageForm.value.ind_id == 9999 || this.locationManageForm.value.sub_ind_id == 9999) {
                if (!this.locationManageForm.value.sub_ind_name) {
                    this.mainService.customPopups('Please enter a valid name for sub industry', 1);
                    return false;
                }
                data['sub_ind_name'] = this.locationManageForm.value.sub_ind_name;
            }
        }

        if (this.isEdit) {
            delete data.ind_id;
            delete data.sub_ind_id;
        }

        let locApi = this.isEdit ? `update_location` : `add_location`;

        this.mainService.api(data, locApi, true, 'object')
            .subscribe(response => {
                if (response.is_error) {
                    return;
                } else {
                    this.isLocationSubmitted = false;
                    this.dialogRef.close(1);
                    if (this.isEdit) {
                        this.mainService.customPopups("Data updated successfuly", 0);
                    }
                    else {
                        this.mainService.customPopups("Data added successfuly", 0);
                    }

                }
            })
    }

    initBusinessDetailsForm() {
        this.businessDetailsForm = this._formBuilder.group({
            'businessName': ['', [Validators.required]],
            'businessEmail': ['', [Validators.required, Validators.email, Validators.pattern(Regex.email_regex)]],
            'businessPhoneNumber': ['', [Validators.required]],
            'accountType': ['', []],
            'managerName': [''],
            'managerEmail': ['', [Validators.pattern(Regex.email_regex)]],
            'managerPhoneNumber': ['']
        });

    }

    patchBusinessDetails() {
      this.businessDetailsForm = this._formBuilder.group({
            'businessName': [((this.data.send_data.practice_name || '')), [Validators.required]],
            'businessEmail': [(this.data.send_data.practice_email), [Validators.required, Validators.email, Validators.pattern(Regex.email_regex)]],
            'businessPhoneNumber': [(((this.data.send_data.practice_mobile ? (this.data.send_data.practice_mobile || '').replace('+1-', '').replace('+1-', '') : ''))), [Validators.required]],
            'accountType': ['', []],
            'managerName': [this.data.send_data.manager_name],
            'managerEmail': [this.data.send_data.manager_email, [Validators.pattern(Regex.email_regex)]],
            'managerPhoneNumber': [((this.data.send_data.manager_mobile ? this.data.send_data.manager_mobile.replace('+1-', '') : ''))]
        });
        // businessName: [(this.data.send_data.practice_name)
        // businessEmail: [(this.data.send_data.practice_email)
        // businessPhoneNumber: [(this.phoneNumberPipe.transform(this.data.send_data.practice_mobile ? this.data.send_data.practice_mobile.replace('+1-', '') : ''))
        // managerName: [(this.data.send_data.manager_name)
        // managerEmail: [(this.data.send_data.manager_email)
        // managerPhoneNumber: [(this.phoneNumberPipe.transform(this.data.send_data.manager_mobile ? this.data.send_data.manager_mobile.replace('+1-', '') : ''))
        if (this.data.send_data.bank_added) {
            this.businessDetailsForm.removeControl('accountType');
        }

        this.businessDetailsForm.updateValueAndValidity();

    }

    updateBusinessDetails() {
        if (this.businessDetailsForm.invalid) {
            this.businessDetailsForm.markAllAsTouched();
            return false;
        }

        if (this.businessDetailsForm.value.businessPhoneNumber == '0000000000') {
            this.mainService.customPopups('Business phone number is invalid.', 1);
            return false;
        }

        if (this.businessDetailsForm.value.managerPhoneNumber == '0000000000') {
            this.mainService.customPopups('Manager phone number is invalid.', 1);
            return false;
        }

        let data = {
            access_token: localStorage.getItem('token'),
            doctor_id: this.data.send_data.doctor_id,
            enterprise_id: this.profile.enterprise_id,
            practice_name: this.businessDetailsForm.controls.businessName.value,
            practice_email: this.businessDetailsForm.controls.businessEmail.value,
            practice_mobile: this.businessDetailsForm.controls.businessPhoneNumber.value,
            manager_name: this.businessDetailsForm.controls.managerName.value || '',
            manager_email: this.businessDetailsForm.controls.managerEmail.value || '',
            manager_mobile: this.businessDetailsForm.controls.managerPhoneNumber.value,
            location_first_name: this.data.send_data.doctor_first_name,
            location_last_name: this.data.send_data.doctor_last_name,
            doctor_email: this.data.send_data.doctor_email,
            doctor_first_name: this.data.send_data.doctor_first_name,
            doctor_last_name: this.data.send_data.doctor_last_name,
            doctor_mobile: this.data.send_data.doctor_mobile
        }
        if (this.businessDetailsForm.controls.managerPhoneNumber.value) {
            data.manager_mobile = '';
            data.manager_mobile = '+1-' + this.businessDetailsForm.controls.managerPhoneNumber.value.replace(/\D+/g, '');
        }
        if (this.businessDetailsForm.controls.businessPhoneNumber.value) {
            data.practice_mobile = '';
            data.practice_mobile = '+1-' + this.businessDetailsForm.controls.businessPhoneNumber.value.replace(/\D+/g, '');
        }
        this.mainService.api(data, `update_location`, true, 'object')
            .subscribe(response => {
                if (response.is_error) {
                    return;
                } else {
                    this.mainService.customPopups('Details updated successfully', 0);
                    this.dialogRef.close(1);
                }
            });

    }
    mobile_num_Validation() {
        if (this.bankDetailsForm.controls.businessPhoneNumber.value == '0000000000') {
            this.bankDetailsForm.controls.businessPhoneNumber.setErrors({ 'incorrect': true });
        }
    }

    checkuserEmployed() {
        let employed: any = '';
        if (this.customerInfo[0]) {
            if (this.customerInfo[0].payback_methods && employed == '') {
                employed = 1;
            }
            // checking employment for status Yes
            if (this.customerInfo[0].employer_name && this.customerInfo[0].employer_name !== null && this.customerInfo[0].employer_address && this.customerInfo[0].employer_address !== null && this.customerInfo[0].employer_address && this.customerInfo[0].employer_address !== null && employed == '') {
                employed = 0;
            }
            console.log(this.customerInfo[0].office_address && this.customerInfo[0].office_address !== null && this.customerInfo[0].profession && this.customerInfo[0].profession !== null && employed == '', this.customerInfo)
            // checking employed for self employed
            if (this.customerInfo[0].office_address && this.customerInfo[0].office_address !== null && this.customerInfo[0].profession && this.customerInfo[0].profession !== null && employed == '') {
                employed = 2;
            }
            this.customerInfo[0]['employed'] = employed;
        }
        return employed;
    }



    SameAddress: any
    FillOfficeAddress(e) {
        if (e.target.checked) {
            this.SameAddress = true
            this.customerDetails.get('office_address').setValue(this.customerDetails.value.address)
            this.getOfficeZipselected(this.zipCode);
            this.customerDetails.get('office_address').disable();
            this.customerDetails.get('office_zip').disable();
            // this.customerDetails.get('office_city').disable();

        }
        else {
            this.SameAddress = false
            this.getOfficeZipselected('');
            this.customerDetails.get('office_address').enable();
            this.customerDetails.get('office_address').setValue('');
            this.customerDetails.get('office_address').markAsPristine();
            // this.customerDetails.get('office_city').enable();
            this.customerDetails.get('office_zip').enable();
        }
        this.customerDetails.updateValueAndValidity();
    }

    calculateUprfont() {
        let newUpfront = 0;
        newUpfront = this.contractData.new_upfront_with_fee;
        newUpfront = newUpfront - this.contractData.old_upfront_with_fee;
        return newUpfront;
    }

    getStartedtoFinance(val, isPPSub = false) {
        this.dialog.closeAll();
        if (val == 1) {
            this.router.navigate(['/app/finance']);
        } else if (val == 2 && !isPPSub) {
            this.router.navigate(['/app/process-payment/payment']);
        } else if (val == 2 && isPPSub) {
            this.router.navigate(['/app/subscriptions/payment'], {
                queryParams: { step: 'overview' },
            });
        } else {
            this.router.navigate(['/app/accounts-receivable/send-invoice']);
        }
    }


    uploadContractDocs(docInfo?, doc?, selected?) {
        try {
            let formData = new FormData();
            formData.append('access_token', localStorage.getItem('token'));
            if (this.data.contract_id) {
                formData.append('contract_id', this.data.contract_id);
            }
            else if(this.data.pp_subscription_id) {
                formData.append('pp_subscription_id', this.data.pp_subscription_id);
            } else{
                formData.append('pp_id', this.data.pp_id);

            }
            if (docInfo && docInfo.is_uploaded == 1 || docInfo && docInfo.need_more_documents == 1) {
                formData.append('is_reupload', '1');
                formData.append('document_id', docInfo.document_id);
            }
            formData.append('doctor_id', this.data.doctor_id);
            if (selected == undefined) {
                let mime = doc.target.files[0].type
                let mineIndex = mime.lastIndexOf('/') + 1
                if (!['pdf', 'jpeg', 'jpg', 'png'].includes(mime.slice(mineIndex))) {
                    this.mainService.customPopups("Please upload a valid file.", 1)
                    return
                }
                if ((doc.target.files[0].size / (1024 * 1024)) > 10) {
                    this.mainService.customPopups("Files more than 10mb are not allowed.", 1);
                    return;
                }
                formData.append('document_type', String(docInfo.document_type_id));
                if (doc.target && doc.target.files[0]) {
                    formData.append('document_file', doc.target.files[0]);
                }
                if (doc.need_more_documents == 1 && doc.document_type_id == 4) {
                    formData.append('doc_note', String(doc.document_name));
                }
            }
            else {
                formData.append('doc_note', String(this.CustomerAdditionalDocs[selected].file_name));
                formData.append('document_file', this.CustomerAdditionalDocs[selected].document_file);
                formData.append('document_type', String(4));
            }
            this.mainService.uploadApi(formData, 'upload_dispute_document', true).subscribe(data => {
                if (data.is_error == 0) {
                    if (selected == undefined) {
                        this.contractDocsRequired = this.contractDocsRequired.map(item => {
                            if ((item.document_type_id == docInfo.document_type_id && item.document_type_id != 4) || (item.document_id == docInfo.document_id && item.document_type_id == 4)) {
                                item.doc_url = data.uploaded_file_details.document_url;
                                item.document_url = data.uploaded_file_details.document_url;
                                item.document_id = data.uploaded_file_details.document_id;
                                item.is_uploaded = 1;
                                if (item.need_more_documents == 1) {
                                    item.need_more_documents = 0;
                                    item.is_submitted = 0;
                                    item.is_uploaded = 1;
                                }
                                else {
                                    item.need_more_documents = 0;
                                }
                            }
                            return item;
                        }).sort((a, b) => a.uploaded == 1 ? a : b);
                    }
                    else {
                        this.CustomDocUploaded(data, selected);
                    }
                    this.mainService.customPopups(formData.get('is_reupload') ? "File Uploaded Successfully" : "File Uploaded Successfully", 0);
                }
                else {
                    this.mainService.customPopups(data.err, 1)
                }
            })

        }
        catch (error) {
            console.log(error)
        }
    }

    getContractDetailsDisputes() {
        let userData = getUserProfile()
        if (userData) {
            let data = {
                access_token: userData.access_token,
                doctor_id: userData.doctor_id,
                contract_id: this.data.contract_id,
                pp_id: this.data.pp_id,
                pp_subscription_id: this.data.pp_subscription_id
            }
            this.mainService.api(data, 'get_doctor_disputes', false).subscribe((data) => {
                if (data.is_error) {
                    this.mainService.customPopups(data.err || 'Oppse something went wrong.', 1);
                    return
                }
                this.contractDocsRequired = data.documents_required.sort((a, b) => a.uploaded == 1 ? b : a);
                this.disutedPayments = data.disputed_payments;
            })
        }
    }

    deleteDoc(doc) {
        try {
            let userData = getUserProfile()

            let data = {
                access_token: userData.access_token,
                doctor_id: userData.doctor_id,
                document_id: doc.document_id
            }

            this.mainService.api(data, 'delete_dispute_document', false).subscribe((item) => {
                if (item.is_error == 0) {
                    if (doc.document_type_id == 4 && doc.need_more_documents == 0 && this.data.code != 4) {
                        this.contractDocsRequired = this.contractDocsRequired.filter((item_1) => {
                            return item_1.document_id != doc.document_id;
                        })
                    }
                    this.contractDocsRequired = this.contractDocsRequired.map(item_1 => {
                        if (item_1.document_id == doc.document_id) {
                            switch (item.status.status) {
                                case "Need More Documents":
                                    item_1.need_more_documents = 1;
                                    this.getContractDetailsDisputes();
                                    break;
                                case "New":
                                case "Pending":
                                case "submitted":
                                    item_1.is_uploaded = 0;
                                    item_1.document_id = null;
                                    break;
                                default:
                                    item.is_uploaded = 0;
                                    item_1.document_id = null;
                                    break;
                            }
                        }
                        return item_1;
                    })

                    this.mainService.customPopups("File Deleted Successfully", 0);
                }
                else {
                    this.mainService.customPopups(item.err, 1)
                }
            });
        } catch (error) {
            console.log(error);
        }
    }


    addMoreDocument() {
        if ((this.contractDocsRequired.length + this.CustomerAdditionalDocs.length) == 10) {
            return;
        }
        this.CustomerAdditionalDocs.push({
            file_name: '',
            document_file: ''
        })
    }

    getFileFromInput(event, index) {

        if ((event.target.files[0].size / (1024 * 1024)) > 10) {
            this.mainService.customPopups("Files more than 10mb are not allowed.", 1);
            return
        }

        let mime = event.target.files[0].type;
        let mineIndex = mime.lastIndexOf('/') + 1;
        if (!['pdf', 'jpeg', 'jpg'].includes(mime.slice(mineIndex))) {
            this.mainService.customPopups("Please upload a valid file.", 1);
            return;
        }
        if ((event.target.files[0].size / (1024 * 1024)) > 10) {
            this.mainService.customPopups("Files more than 10mb are not allowed.", 1);
            return;
        }


        let data = this.CustomerAdditionalDocs[index];

        if (data.file_name == '') {
            this.mainService.customPopups('Please add a valid File Name', 1);
            return;
        }

        this.CustomerAdditionalDocs[index].document_file = event.target.files[0];
        this.uploadContractDocs('', '', index);
    }



    CustomDocUploaded(data, selected) {
        let custom_obj = {
            ...data.uploaded_file_details,
            doc_url: data.uploaded_file_details.document_url,
            is_uploaded: 1,
            is_required: 0,
            is_submitted: 0,
            document_type_id: 4,
            need_more_documents: 0
        }
        this.contractDocsRequired.push(custom_obj);
        this.CustomerAdditionalDocs = this.CustomerAdditionalDocs.filter((item, index) => {
            return index != selected;
        })
    }

    getPendingFiles(data, useDoc?) {
        // 0. to get normal value
        // 1. to get Documents in string value
        // 2. to get uploaded Documents in string value
        let requireddocs = 0;
        let uploadedddocs = 0;
        data.forEach(item => {
            if (item.is_uploaded == 0 || item.need_more_documents == 1) {
                requireddocs = requireddocs + 1
            }
            if (item.is_uploaded == 1 && item.need_more_documents == 0) {
                uploadedddocs = uploadedddocs + 1
            }
        })

        let title = 'File';

        if (requireddocs > 0) {
            if (useDoc == 1 || useDoc == 2) {

                title = 'Document';
            }
        }
        if (uploadedddocs > 1) {

            title += 's';
        }

        return (requireddocs == 0 && useDoc != 2) ? '' : String(useDoc == 2 ? data.length - requireddocs : requireddocs) + ' ' + title + ' ' + (useDoc == 2 ? ' Uploaded' : ' Pending');
    }

    checkRemainingUploads(i?) {
        return this.contractDocsRequired.some((item) => item.is_uploaded == (i ? i : 0) /* && item.need_more_documents != 1 */)
    }

    submitDocs() {
        let pending_docs = this.contractDocsRequired.some((item) => item.need_more_documents == 0);
        if (this.data.code == 4 && !pending_docs) {
            this.mainService.customPopups("Please upload atleast one document", 1);
            return;
        }
        let userData = getUserProfile();

        if (!this.contractDocsRequired.some((item) => item.is_uploaded == 1)) {
            this.mainService.customPopups("Please upload atleast one document", 1);
            return;
        }

        if (this.contractDocsRequired.some(item => item.is_uploaded == 0 && item.is_required == 1)) {
            this.mainService.customPopups("Please upload all required documents", 1);
            return;
        }

        let data = {
            access_token: userData.access_token,
            contract_id: this.data.contract_id,
            doctor_id: userData.doctor_id,
            note: this.changeReason,
            pp_id: this.data.pp_id
        }
        if(this.data.pp_subscription_id){
            data['pp_subscription_id'] = this.data.pp_subscription_id;
        } else {
            data['contract_id'] = this.data.contract_id;
        }

        if (this.data.code == 4) {
            data['doc_submit_arr'] = JSON.stringify(this.contractDocsRequired.filter(item => item.need_more_documents == 0).map(item => item.document_id) || []);
            data['doc_remaining_arr'] = JSON.stringify(this.contractDocsRequired.filter(item => item.need_more_documents == 1).map(item => item.document_id) || []);
        }
        this.mainService.api(data, 'submit_documents', false).subscribe((response) => {
            if (response.is_error) {
                this.mainService.customPopups(response.err || "something went wrong", 1);
                return
            }
            setTimeout(() => {
                this.is_submitted = 1;
            }, 0);
        })
    }

    customDocument(doc) {
        if (!doc.file_name) {
            this.mainService.customPopups("Please add document name", 1);
            return false;
        }
        return true;
    }


    checkAllNeedMoreDocs() {
        return this.contractDocsRequired.every(item => item.need_more_documents == 1)
    }

    updateCity(value, type){
        if(!value){
            return;
        }
        // tslint:disable-next-line:max-line-length
        if(type == 'user_data' && value && this.zipCode.city != value ){
          this.zipCode.city  = value
          this.getZipCode(this.zipCode, type)
        // tslint:disable-next-line:max-line-length
        }else if(type == 'employed_data' && value && this.empZipCode && this.empZipCode.city != value ){
            this.empZipCodeData.city = value;
            this.getZipCode(this.empZipCodeData, type)
          // tslint:disable-next-line:max-line-length
        }  else if(type == 'office_data' && this.customerDetails.controls.office_city && this.customerDetails.controls.office_city.value && this.office_zipObj.city != this.customerDetails.controls.office_city.value ){
          this.office_zipObj.city  = this.customerDetails.controls.office_city.value
          this.getZipCode(this.office_zipObj, type)
        }
    }

    showLabel() {
        // let endDate = new Date(this.pay_info.deferred_end_date)
        try {
          let EndDate = moment(this.contractData.deferred_end_date).unix();
          let ChoosenDate = moment(this.edit_recurring_data.payment_date,'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).unix();

          // Compare the dates using JavaScript

          this.edit_recurring_data.showLabel = EndDate < ChoosenDate ? true : false;
        } catch (error) {
          console.log(error);
        }

      }

    getZipCode(item: any, type?) {
        const combin_data: any = {};
        combin_data[type] = {
          addressObj: item
        }
        this.mainService.api(combin_data, `add_address`, false)
          .subscribe(response => {
            if (!response.is_error) {
              console.log(response, 'response');
              // tslint:disable-next-line:max-line-length
              if (response && response.data && (response.data.user_data.length || response.data.emp_data.length || response.data.office_data.length)) {
                if(type == 'user_data' || type == 'user_data'){
                  this.zipCode = response.data.user_data[0];
                } else if(type == 'employed_data'){
                    this.empZipCodeData = response.data.emp_data[0];
                } else{
                  this.office_zipObj = response.data.office_data[0];
                  this.customerDetails.controls.office_city_id.setValue(this.office_zipObj && this.office_zipObj.city_id || 0);
                }
              } else {
                // this.setAddress.emit(response);
              }
            } else {
              console.log(response.override_text);
            }
          });
      }


  getCardBrandImage(card): string {
    if (card) {
      let brand = (card.brand || card.card.brand).toLowerCase();
      let allowedBrands = ['mastercard', 'discover', 'jcb', 'visa', 'american express', "unionpay", 'diners', 'amex'];
      if (brand === 'american express' || brand == 'amex') {
        return `assets/img/svg/card-type/American Express.svg`;
      }
      if (brand === 'mastercard') {
        return `assets/img/svg/card-type/MasterCard.svg`;
      }
      if (brand === 'unionpay') {
        return `assets/img/svg/card-type/UnionPay.svg`;
      }
      if (brand === 'diners') {
        return `assets/img/svg/card-type/Diners Club.svg`;
      }
      if (brand === 'jcb') {
        return `assets/img/svg/card-type/JCB.svg`;
      }
      return brand && allowedBrands.includes(brand)
        ? `assets/img/svg/card-type/${this.capitalizeFirstLetter(brand)}.svg`
        : 'assets/img/svg/card-type/no_card.svg';
    }
  }
  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


  setLiHeight(container, setValue) {
    setTimeout(() => {
      if (container) {
        // Use scrollHeight or offsetHeight of the li to get content height
        this[setValue] = container.nativeElement.querySelector('.content_frame').scrollHeight || container.nativeElement.querySelector('.content_frame').offsetHeight;
        // if( (this[setValue] == 480 && setValue == 'liHeight') || (this[setValue] < 480 && setValue == 'liHeight')) {
          this[setValue] = this[setValue] + 15; // Set a minimum height

        // if( (this[setValue] == 421 && setValue == 'bankliHeight') || (this[setValue] < 421 && setValue == 'bankliHeight')) {
        //   this[setValue] = this[setValue] + 50; // Set a minimum height
        // }
      }
    }, 50);
  }

  onFieldBlur() {
    this.setLiHeight(this.businessDetailsLi, 'liHeight');
  }

  onFieldBlur2() {
    this.setLiHeight(this.bankDetailsLi, 'bankliHeight');
  }


  checkCurrentForm(event, formOpened) {
    if(formOpened == 2 || formOpened == 3 || formOpened == 1) {

      console.log(this.businessStripeDetailsForm, 'businessStripeDetailsForm');``

      if((formOpened == 2 || formOpened == 3) && this.currentStripeForm != formOpened) {
        this.businessStripeDetailsForm.markAllAsTouched();
      }

      if(this.businessStripeDetailsForm.invalid) {
        this.setLiHeight(this.businessDetailsLi, 'liHeight');
        if(event) event.preventDefault();
        return;
      }

      if((formOpened == 3) && this.currentStripeForm != formOpened) {
        this.bankDetailsForm.markAllAsTouched();
      }

      if(this.bankDetailsForm.invalid && formOpened == 3) {
        this.setLiHeight(this.bankDetailsLi, 'bankliHeight');
        if(event) event.preventDefault();
        return;
      }

      if(this.currentStripeForm == formOpened && this.currentStripeForm == 3) {
         if(event) event.preventDefault();
        this.consentForm.markAllAsTouched();
        return
      }

      if(!this.businessStripeDetailsForm.valid || (!this.bankDetailsForm.valid && this.currentStripeForm == formOpened) || (!this.consentForm.valid && this.currentStripeForm == formOpened)) {
          if(event) {
          event.preventDefault();
        }
      } else this.currentStripeForm = formOpened;

    }

    return
  }



  ngOnDestroy() {
    this.profile_subscriber && this.profile_subscriber.unsubscribe();
  }


einValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let ein = control.value.split('');
    ein.splice(2,0, '-');
    ein = ein.join('')
    if (!ein) return null; // don't validate empty value (let required handle it)

    const einRegex = /^\d{2}-\d{7}$/;
    if (!einRegex.test(ein)) {
      return { invalidEINFormat: true };
    }

    const prefix = parseInt(ein.substring(0, 2), 10);
    if (prefix === 0) {
      return { invalidEINPrefix: true };
    }

    return null;
  };
}

 ssnValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const ssn: string = control.value;

    if (!ssn) return null; // Let required validator handle empty case

    const cleaned = ssn.replace(/-/g, '');

    if (!/^\d{9}$/.test(cleaned)) {
      return { invalidSSNFormat: true };
    }

    const area = parseInt(cleaned.substring(0, 3), 10);
    const group = parseInt(cleaned.substring(3, 5), 10);
    const serial = parseInt(cleaned.substring(5, 9), 10);

    if (area === 0 || area === 666) {
      return { invalidSSNArea: true };
    }

    if (group === 0) {
      return { invalidSSNGroup: true };
    }

    if (serial === 0) {
      return { invalidSSNSerial: true };
    }
    if (cleaned === '123456789') {
      return { invalidSSNSerial: true };
    }


    return null;
  };
}

    noTrailingSpaceValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value && value.endsWith('  ')) {
                return { trailingSpace: true };
            }
            return null;
        }
    }

}

export interface DialogData {
    title?: string;
    desc?: string;
    action?: string;
    actionClass?: string;
    type?: any;
    contract_id?: any;
    paymentInfo: boolean;
    send_data?: any;
    popup_data?: { tips_text?: {} }
    email?: any;
    added?: any;
    allContracts?: any;
    downloadPdf?: any;
    noFeePaymentCards?: any;
    customNoFeeAvailableMonth?: any;
    filteredArray?: any;
    paymentType?: any;
    downpaymentCost?: any;
    interestRateAmt?: any;
    doctor_id?: any;
    totalServAmt?: any;
    estimatedServiceCost?: any;
    contract_code?: any;
    pp_id?: any;
    pp_code?: any;
    code?: any;
    disutedPayments: any;
    contractDocsRequired: any;
    cancelContractConnectedAccountAllow: any;
    pp_subscription_id?: any;
    pp_subscription_code?: any;
    payment_process_code?: any;
    loan_amount?: any;
    offer_id?: any;
}
